/*
 * Treść startowa serwisu prawly.
 *
 * To jest "fabryczna" zawartość CMS-a — wszystko, co administrator może
 * później zmienić w panelu /admin. Store (cms/store.js) trzyma nakładkę
 * z edycjami i scala ją z tym plikiem, więc seed pozostaje nienaruszony
 * i zawsze można wrócić do stanu wyjściowego.
 */

/* Strony docelowe pod reklamy — fabryczne wartości trzymamy w JSON-ie obok
   komponentu, bo czyta je też skrypt prerenderu (scripts/prerender-landings.mjs),
   który nie umie importować tego pliku. */
import LANDINGS from "../landing/landings.json";
import LANDING_SHARED from "../landing/landingShared.json";
import GOOGLE_REVIEWS from "../landing/googleReviews.json";

export const SEED = {
  /* ------------------------------------------------------- ustawienia ogólne */
  settings: {
    brand: "prawly",
    tagline: "porady prawne online",
    claim: "Pisemna opinia prawna i gotowe dokumenty — podpisane przez radcę prawnego.",
    email: "kontakt@prawly.pl",
    googleReviewUrl: "https://g.page/r/CVIo62MH0WHeEBM/review",
    phone: "+48 455 571 576",
    hours: "pon.–pt. 9:00–17:00",
    address: "ul. Sarnia 4, 52-129 Wrocław",
    company: "A2 Synergy Adrian Tomys",
    nip: "PL9231689650",
    socials: {
      linkedin: "",
      facebook: "",
      x: "",
    },
    seo: {
      title: "prawly. — porady prawne online",
      description:
        "Pomoc prawna online, świadczona przez doświadczonych radców prawnych. Odbierz pisemną opinię albo dokument podpisany przez radcę prawnego w ciągu 12 godzin roboczych.",
    },
    notice:
      "Prawly jest platformą technologiczną, a nie kancelarią. Pomoc prawną świadczą radcowie prawni z OLC Kancelaria Radców Prawnych Artymionek & Citko Sp. k. — na własną odpowiedzialność zawodową.",
  },

  /* ------------------------------------------------------ strona główna */
  home: {
    hero: {
      eyebrow: "Porady prawne online",
      title: "Pomoc prawna online ",
      titleEm: "świadczona przez doświadczonych radców prawnych.",
      lead:
        "Opisujesz problem, a w ciągu 12 godzin roboczych otrzymasz pisemną ==opinię== albo gotowy ==dokument==.",
      ctaPrimary: { label: "Zamów poradę", href: "/cennik" },
      ctaSecondary: { label: "Jak to działa", href: "/jak-to-dziala" },
      /* Pusty adres = wbudowana ilustracja zespołu (components/HeroArt.jsx). */
      image: "/hero-lawyer.jpg",
      imageAlt: "Radca prawny przedstawia klientom rozwiązanie ich sprawy",
      badges: ["Jasne zasady, rzetelna usługa", "Terminowa realizacja usługi"],
    },
    /* Skrócona, wczesna wersja treści z sekcji "Odpowiedzialność" niżej na
       stronie (home.trust) — te same fakty (podpis i numer wpisu, OC
       zawodowe, ciągłość prowadzenia sprawy), tylko w trzech krótkich
       zdaniach zamiast pełnego akapitu. Ma dawać poczucie pewności OD RAZU
       pod hero, zanim ktoś zdąży przewinąć do pełnej sekcji albo w ogóle
       stronę opuści — bez odwoływania się do ceny (to już robią badges w
       hero i sekcja "Oferta") i bez porównań do kogokolwiek, wyłącznie fakty
       o odpowiedzialności zawodowej. */
    credibility: {
      eyebrow: "Zanim zapytasz",
      title: "Za opinią stoi konkretna osoba — i przepisy, które ją do tego zobowiązują",
      items: [
        {
          t: "Radca prawny z numerem wpisu",
          d: "Imię, nazwisko i numer wpisu na każdym dokumencie — wiesz, kto odpowiada.",
        },
        {
          t: "Ubezpieczenie OC zawodowe",
          d: "Pełna odpowiedzialność zawodowa, tak jak w każdej kancelarii.",
        },
        {
          t: "Jedna osoba, cała sprawa",
          d: "Sprawę od początku do końca prowadzi ten sam prawnik.",
        },
      ],
    },
    stats: [
      { value: "10+ lat", label: "doświadczenia zespołu OLC Kancelaria Radców Prawnych" },
      { value: "12 h", label: "roboczych — gwarantowany czas na pisemną odpowiedź" },
      { value: "100%", label: "opinii podpisanych przez radcę prawnego lub adwokata" },
      { value: "6", label: "obszarów specjalizacji prawnej" },
    ],
    steps: [
      {
        t: "Wybierasz usługę",
        d: "Opinia prawna albo gotowy dokument. Stała cena znana z góry, płatność online.",
      },
      {
        t: "Opisujesz sprawę",
        d: "Własnymi słowami, o dowolnej porze. Fakty, daty, dokumenty — im więcej, tym trafniej.",
      },
      {
        t: "Prawnik opracowuje",
        d: "Radca prawny weryfikuje stan faktyczny, uzupełnia podstawy prawne i redaguje treść.",
      },
      {
        t: "Odbierasz podpisany PDF",
        d: "Pisemna odpowiedź z pieczęcią, podpisem i numerem wpisu prawnika — do pobrania.",
      },
    ],
    trust: {
      eyebrow: "Odpowiedzialność",
      title: "Za każdą odpowiedzią stoi konkretny prawnik",
      body:
        "Każdą odpowiedź opracowuje, redaguje i podpisuje imieniem, nazwiskiem oraz numerem wpisu radca prawny — i to on bierze za nią odpowiedzialność zawodową. Nie dostaniesz od nas tekstu, za którym nie stoi konkretna osoba: na dokumencie PDF i w historii sprawy zawsze widzisz, kto firmuje treść.",
      points: [
        "Treść opracowuje i zatwierdza radca prawny prowadzący sprawę.",
        "Każdy dokument nosi imię, nazwisko i numer wpisu radcy prawnego.",
        "Pełna historia sprawy dostępna w panelu klienta bez ograniczeń czasowych.",
        "Ubezpieczenie OC zawodowe po stronie prawnika prowadzącego sprawę.",
      ],
    },
    areas: {
      eyebrow: "Dziedziny",
      title: "W czym pomagamy najczęściej",
      lead: "Prowadzimy sprawy z zakresu prawa codziennego — tam, gdzie wizyta w kancelarii bywa nieproporcjonalna do problemu.",
      items: [
        { icon: "§", t: "Prawo cywilne", d: "Umowy, rękojmia, odszkodowania, sprawy sąsiedzkie, spory z kontrahentem." },
        { icon: "⚖", t: "Prawo pracy", d: "Wypowiedzenia, mobbing, zaległe wynagrodzenie, umowy i zakaz konkurencji." },
        { icon: "◈", t: "Prawo konsumenckie", d: "Reklamacje, zwroty, nieuczciwe klauzule, spory z bankiem i ubezpieczycielem." },
        { icon: "⌂", t: "Nieruchomości", d: "Najem, wspólnoty, służebności, sprawy o zapłatę i wydanie lokalu." },
        { icon: "❋", t: "Prawo rodzinne", d: "Alimenty, kontakty z dzieckiem, rozdzielność majątkowa, podział majątku." },
        { icon: "▤", t: "Firma i działalność", d: "Umowy B2B, windykacja, RODO, regulaminy sklepów i serwisów." },
      ],
    },
    testimonials: {
      "items": [
        {
          "label": "",
          "quote": "Prawly pozwala uzyskać w szybki sposób poradę prawną w pełni bezpieczną i profesjonalną. Pokazuje, że praca prawnika może być dobrze wspierana przez technologię."
        },
        {
          "role": "Wrocław, prawo pracy",
          "quote": "Portal daje możliwość zadania pytań, z jakimi normalnie nie pójdzie się do kancelarii prawnej – czy to z braku czasu, czy to z powodu braku takiej możliwości. Zbliża człowieka do uzyskania porady prawnej w sposób szybki i bezpieczny.",
          "author": "Marta K."
        },
        {
          "role": "Gdańsk, umowa B2B",
          "quote": "Nowoczesne technologie powinny wspierać pracę człowieka. Tak się dzieje w przypadku Prawly – prawnik otrzymuje wsparcie w zakresie wyszukania informacji, dzięki czemu może udzielić pełniejszej i lepszej informacji Klientowi, który dzięki temu może uzyskać niezbędną poradę szybko i o jak najlepszej jakości.",
          "author": "Tomasz W."
        },
        {
          "role": "Katowice, sprawa spadkowa",
          "quote": "Kancelarie prawne są często niedostępne dla zwykłego człowieka – Prawly stara się to zmienić. Łatwość zadawania pytań i niewygórowana cena pozwalają każdemu skorzystać z usług prawnych, niezależnie od tego jak błahy wydaje się być dany problem. Prawly pozwala wszystkim uzyskać pewność co do problemów, które mogą pojawić się w życiu codziennym każdego człowieka.",
          "author": "Anna S."
        }
      ],
      "title": "Co mówią o prawly",
      "eyebrow": "Opinie"
    },
    cta: {
      "lead": "Wycena jest znana z góry, a termin liczy się od momentu opłacenia sprawy.",
      "title": "Masz problem prawny? Opisz go dziś.",
      "primary": {
        "href": "/panel/nowa",
        "label": "Załóż sprawę"
      },
      "secondary": {
        "href": "/kontakt",
        "label": "Porozmawiaj z nami"
      }
    },
  },

  /* ------------------------------------------------------------- o nas */
  about: {
    hero: {
      eyebrow: "O nas",
      title: "Prawo bywa niedostępne nie dlatego, że jest trudne.",
      lead:
        "Bywa niedostępne, bo wymaga wolnego dnia, dojazdu i rozmowy, w której trzeba od razu wiedzieć, o co zapytać. Zbudowaliśmy prawly, żeby usunąć te trzy przeszkody — nie obniżając poprzeczki merytorycznej.",
    },
    mission: {
      eyebrow: "Misja",
      title: "Rzetelna pomoc prawna w cenie i terminie, które znasz z góry",
      body:
        "Wierzymy, że dostęp do prawnika nie powinien zależeć od tego, czy ktoś ma znajomego po aplikacji ani czy stać go na godzinę w kancelarii przy dobrym adresie. Naszą misją jest udostępnić pisemną, podpisaną pomoc prawną każdemu, kto potrafi opisać swój problem własnymi słowami — w stałej cenie, w przewidywalnym terminie i bez konieczności tłumaczenia się z tego, że czegoś się nie wie.\n\nTechnologia jest u nas narzędziem, nie obietnicą. Formalności, obieg dokumentów i porządkowanie materiału bierze na siebie platforma, żeby prawnik mógł zajmować się tym, do czego jest potrzebny — oceną sprawy i decyzją. Klient dostaje z tego jedno: pisemną odpowiedź, za którą odpowiada człowiek z numerem wpisu.",
    },
    values: [
      {
        t: "Jasna cena, zanim zaczniemy",
        d: "Kwotę widzisz przed opłaceniem sprawy. Nie rozliczamy się co godzinę i nie dopisujemy pozycji po fakcie. Jeżeli pytanie uzupełniające wykracza poza usługę, prawnik poda cenę przed rozpoczęciem pracy.",
      },
      {
        t: "Podpis zamiast anonimowej porady",
        d: "Każda opinia i każdy dokument nosi imię, nazwisko i numer wpisu konkretnego radcy prawnego. To on ponosi odpowiedzialność zawodową za treść — nie platforma, nie algorytm.",
      },
      {
        t: "Język, który da się zrozumieć",
        d: "Piszemy tak, żeby dało się przeczytać bez słownika. Podstawa prawna jest w dokumencie zawsze, ale obok niej znajdziesz wyjaśnienie, co to praktycznie oznacza i jaki jest następny krok.",
      },
      {
        t: "Termin traktowany serio",
        d: "Deklarowany czas realizacji to zobowiązanie, a nie orientacyjna sugestia. Sprawę widzisz w panelu na każdym etapie i wiesz, kto się nią zajmuje.",
      },
    ],
    story: {
      eyebrow: "Jak powstaliśmy",
      title: "Zaczęło się od kilkuset pytań bez odpowiedzi",
      body:
        "Prawly wyrósł z prostej obserwacji: większość problemów prawnych, z którymi ludzie zostają sami, nie wymaga procesu ani wielomiesięcznej obsługi. Wymaga jednej rzetelnej odpowiedzi na piśmie — takiej, którą można pokazać drugiej stronie.\n\nPierwsze sprawy prowadziliśmy ręcznie, we trójkę, na współdzielonym arkuszu. Kiedy okazało się, że najwięcej czasu pochłania nie analiza prawna, lecz uporządkowanie opisu sprawy i redakcja dokumentu, zbudowaliśmy narzędzia, które biorą tę część na siebie. Prawnik zyskał czas na to, do czego jest potrzebny — na ocenę i decyzję.",
      milestones: [
        { year: "2023", t: "Pierwsze sto spraw", d: "Zespół trzech radców prawnych, wyłącznie opinie pisemne." },
        { year: "2024", t: "Platforma i panel klienta", d: "Pełna historia sprawy, płatności online, dokumenty w PDF." },
        { year: "2025", t: "Krótsze terminy realizacji", d: "Uporządkowany obieg sprawy skraca czas opracowania o połowę." },
        { year: "2026", t: "Siedemnastu radców, sześć dziedzin", d: "Stały zespół i przewidywalne terminy w całej ofercie." },
      ],
    },
    firm: {
      eyebrow: "Obsługa prawna",
      title: "Za obsługą prawną portalu stoi kancelaria radców prawnych",
      lead:
        "Prawly odpowiada za technologię, obieg sprawy i kontakt z klientem. Za merytorykę — kancelaria, której radcowie prawni prowadzą i podpisują sprawy zakładane przez portal.",
      name: "OLC Kancelaria Radców Prawnych Artymionek & Citko Sp. k.",
      form: "spółka komandytowa",
      address: "ul. Sarnia 4/1, 52-129 Wrocław",
      branches: "Oddziały: Warszawa, Gdańsk",
      site: "https://kancelaria-olc.pl",
      /* Wgraj plik do prawly/public/ i podaj tu ścieżkę, np. /olc-logo.png.
         Puste pole = zastępczy znak tekstowy „OLC”. */
      logo: "/olc-logo.png",
      logoAlt: "OLC Kancelaria Radców Prawnych Artymionek & Citko",
      body:
        "Kancelaria prowadzi zarówno sprawy osób prywatnych, jak i stałą obsługę przedsiębiorców — od jednoosobowych działalności po spółki. Ta sama kadra, która reprezentuje klientów w sporach sądowych, opracowuje opinie i dokumenty zamawiane przez prawly.\n\nDzięki temu odpowiedź, którą otrzymujesz, nie powstaje w oderwaniu od praktyki procesowej: jest pisana przez osoby, które na co dzień widzą, jak dane stanowisko broni się przed sądem i jak reaguje na nie druga strona.",
      specialtiesTitle: "Dziedziny wiodące kancelarii",
      specialties: [
        "Kredyty frankowe (CHF)",
        "Kredyty walutowe (EUR, USD)",
        "Sankcja kredytu darmowego (SKD)",
        "Służebność przesyłu",
        "Polisolokaty i odzyskiwanie opłat likwidacyjnych",
        "Ubezpieczenie niskiego wkładu własnego (UNWW)",
      ],
      servicesTitle: "Pozostały zakres praktyki",
      services: [
        "Bieżąca obsługa prawna osób prywatnych i firm",
        "Zakładanie spółek i obsługa korporacyjna",
        "Windykacja należności",
        "Odszkodowania",
        "Obsługa startupów oraz małych i średnich przedsiębiorstw",
      ],
      note:
        "Pomoc prawna zamawiana przez prawly jest świadczona przez radców prawnych kancelarii, na ich własną odpowiedzialność zawodową i w granicach obowiązujących ich zasad etyki.",
    },

    team: {
      eyebrow: "Zespół",
      title: "Ludzie, którzy podpisują się pod odpowiedziami",
      lead: "Wszyscy prowadzący sprawy w prawly są czynnymi radcami prawnymi wpisanymi na listę okręgowej izby.",
    },
  },

  /* --------------------------------------------------------- zespół (CRUD) */
  team: [
    {
      "id": "imugnxmg8b01z",
      "bar": "WR-2737",
      "bio": "Partner w OLC Kancelarii Radców Prawnych Artymionek & Citko Sp. k. zajmującej się prowadzeniem spraw z zakresu kredytów indeksowanych i denominowanych do franka szwajcarskiego, szeroko rozumianego prawa bankowego oraz zarządzania i obrotem spółkami prawa handlowego. Absolwent Uniwersytetu Wrocławskiego, gdzie w 2010 r. ukończył studia magisterskie z zakresu Prawa.\n \nRadca prawny od 2014 r. Prowadzi liczne spory sądowe z bankami z zakresu umów indeksowanych i denominowanych. Zajmuje się procesami cywilnymi, a także procesami wyborczymi. Procesualista skupiający się na tworzeniu strategii procesowych dla poszczególnych spraw.\n \nJest autorem licznych publikacji zarówno związanych z prawem bankowym, jak i postępowaniem administracyjnym, sądowoadministracyjnym oraz prawem wyborczym. Prowadzi liczne szkolenia i wykłady, w tym także szkolenia dla jednostek samorządu terytorialnego. Współpracuje z kilkoma wydawnictwami.  Specjalizuje się w zakresie obsługi jednostek medycznych, w tym największych szpitali i przychodni w województwie dolnośląskim.",
      "name": "Adam Citko",
      "role": "Radca prawny · prawo bankowe · prawo spółek · prawo wyborcze · prawo administracyjne",
      "initials": "AC"
    },
    {
      "id": "imugo1hst49oo",
      "bar": "WR-2708",
      "bio": "Partner w OLC Kancelarii Radców Prawnych Artymionek & Citko Sp. k. z siedzibą we Wrocławiu, która jest liderem w skali całego kraju w prowadzeniu spraw z zakresu kredytów indeksowanych i denominowanych do franka szwajcarskiego, szeroko rozumianego prawa bankowego oraz zarządzania i obrotem spółkami prawa handlowego.\n\nAbsolwent Uniwersytetu Wrocławskiego, gdzie w 2010 r. ukończył studia magisterskie z zakresu Prawa oraz rok później studia magisterskie z zakresu Administracji.  \nJako radca prawny pracuje od 2014 r., swoją wiedzę od samego początku wykorzystuje w zakresie zarządzania firmą oraz zdobywania doświadczenia biznesowego.\n\nAutor kilkudziesięciu publikacji z dziedziny postępowania administracyjnego, sądowoadministracyjnego, bankowego i korporacyjnego. Współpracuje z kilkoma firmami szkoleniowymi w Polsce, prowadząc szkolenia o tematyce prawnej, dodatkowo prowadzi liczne szkolenia w urzędach administracji publicznej z zakresu prawa podatkowego, postępowania administracyjnego i podatkowego.\n \nW latach 2014-2017 był członkiem Samorządowego Kolegium Odwoławczego we Wrocławiu, gdzie zdobył bogate doświadczenie z zakresu spraw będących we właściwościach samorządowych organów administracyjnych. Specjalista w zakresie obsługi jednostek medycznych, w tym największych szpitali i przychodni w województwie dolnośląskim.",
      "name": "Paweł Artymionek",
      "role": "Radca prawny · prawo spółek · ochrona zarządu  · prawo pracy",
      "initials": "PA"
    },
    {
      "id": "imugo653bgc2c",
      "bar": "WR-3271",
      "bio": "Radca prawny wpisany na listę prowadzoną przez Okręgową Izbę Radców Prawnych we Wrocławiu, posiada szeroką praktykę w działalności prawniczej. Swoją praktykę początkowo skupiał przede wszystkim na obsłudze jednostek samorządu terytorialnego przygotowując opinie prawne dotyczące różnych aspektów działalności samorządu gminnego. Jednocześnie angażował się w prace stowarzyszeń i różnych podmiotów 3 sektora przygotowując statuty, uchwały organów czy prowadząc walne zgromadzenia.\n\nPosiada szeroką praktykę w ramach prowadzonych procesów odszkodowawczych i reprezentowania klientów przed sądami w postępowaniach przeciwko towarzystwom ubezpieczeń. W ramach współpracy z kancelariami wrocławskimi obsługiwał również przedsiębiorców zastępując klientów w postępowania przed sądami powszechnymi, egzekucyjnym jak również opiniując oraz przygotowując umowy wykorzystywane w obrocie gospodarczym.\n\nPracując w towarzystwie funduszy inwestycyjnych prowadził obsługę korporacyjną samego towarzystwa, funduszy inwestycyjnych oraz spółek zależnych. Ponadto ściśle współpracował z inspektorem ds. nadzoru oraz inspektorem ds. compliance przygotowując wewnętrzne procedury zgodności oraz zajmując się danymi osobowymi. Obecnie prowadzi aktywnie doradztwo w zakresie ochrony danych osobowych w związku z wejściem RODO. Głównymi odbiorcami jego usług są placówki oświatowe oraz medyczne zarówno szpitale jak i prywatne praktyki lekarskie. Pełnił również funkcję IOD w szkołach doradzając w zakresie nałożonych na nie obowiązków.",
      "name": "Mateusz Siejko",
      "role": "Radca prawny · prawo bankowe · prawo zobowiązań · ochrona danych osobowych",
      "initials": "MS"
    },
    {
      "id": "imumg675mv51i",
      "bar": "WRO/Adw/1747",
      "bio": "Absolwentka studiów magisterskich Wydziału Prawa i Administracji Uniwersytetu Szczecińskiego na kierunku Prawo oraz studiów magisterskich na Wydziale Prawa, Administracji i Ekonomii Uniwersytetu Wrocławskiego na kierunku Administracja.  Odbywała aplikację adwokacką w Okręgowej Radzie Adwokackiej we Wrocławiu. Następnie w 2015 r. została wpisana na listę adwokatów Wrocławskiej Izby Adwokackiej. W 2012 r. ukończyła studia podyplomowe na Uniwersytecie Ekonomicznym w Poznaniu na kierunku Podatki i Skarbowość. Od 2020 r. po ukończonym szkoleniu w Centrum Mediacji przy Naczelnej Radzie Adwokackiej wpisana na listę stałych mediatorów przy Sądzie Okręgowym we Wrocławiu. Świadczy usługi prawne również w języku angielskim.\n \nW pracy zawodowej kieruje się przede wszystkim indywidualnym podejściem i otwartością na potrzeby klienta,  które w następstwie kompleksowej oceny danej sprawy zapewni skuteczne rozwiązanie problemu prawnego. Na co dzień stara się być dla klientów zaufanym doradcą, na którym zawsze mogą polegać.",
      "name": "Olga Chowańska-Prus",
      "role": "Adwokat  · prawo bankowe · prawo rodzinne · prawo karne",
      "initials": "OC"
    },
    {
      "id": "imumg8vcciknq",
      "bar": "WRO/Adw/3135",
      "bio": "Absolwentka Uniwersytetu Śląskiego, gdzie w 2016 r. ukończyła studia magisterskie z zakresu Prawa. W chwili obecnej adwokat wpisany na listę prowadzoną przez Okręgową Radę Adwokacką we Wrocławiu.\n\nWspółpracowała z dużymi kancelariami, w których zdobywała doświadczenie w różnych dziedzinach prawa. Posiada wieloletnią praktykę w działalności prawniczej wynikającym z reprezentacji  stron w licznych postępowaniach sądowych w sprawach cywilnych i karnych oraz spadkowych i rodzinnych. Aktualnie zajmuje się prowadzeniem spraw związanych z dochodzeniem roszczeń od banków z tytułu umów kredytowych indeksowanych lub denominowanych do franka szwajcarskiego.",
      "name": "Katarzyna Nowak",
      "role": "Adwokat  · prawo bankowe · prawo pracy · prawo karne",
      "initials": "KN"
    },
    {
      "id": "imumgdu73sbzj",
      "bar": "WRO/Adw/923",
      "bio": "Adwokat z ponad 10-letnim doświadczeniem procesowym wynikającym z reprezentacji  stron w licznych postępowaniach sądowych w różnorodnych sprawach cywilnych i karnych. Ma szerokie doświadczenie w sprawach związanych z dochodzeniem roszczeń odszkodowawczych za szkody na osobie, spadkowych oraz rodzinnych. Prowadzi liczne spory z bankami z tytułu umów kredytowych indeksowanych lub denominowanych do franka szwajcarskiego. Prowadziła również obrony w sprawach karnych z zakresu przestępstw przeciwko mieniu, przeciwko życiu i zdrowiu, przeciwko bezpieczeństwu w komunikacji, przeciwko obrotowi gospodarczemu, a także w postępowaniu wykonawczym. Reprezentowała też osoby pokrzywdzone przestępstwem w postępowaniu przygotowawczym i sądowym.",
      "name": "Sabina Moruś-Budny",
      "role": "Adwokat  · prawo zobowiązań · prawo bankowe · prawo karne",
      "initials": "SM"
    },
    {
      "id": "imumgfg79am1g",
      "bar": "LB-1805",
      "bio": "Radca prawny z wieloletnim doświadczeniem w obsłudze osób fizycznych, w tym reprezentacja przed sądami powszechnymi oraz organami administracji publicznej.  Jej doświadczenie obejmuje również bieżące doradztwo oraz reprezentację w toku procesu cywilnego, czy też w toku postępowania administracyjnego podmiotów gospodarczych, zakładanie spółek prawa handlowego poczynając od wyboru optymalnej struktury prawno-podatkowej dla konkretnej działalności, aż do uzyskania postanowienia sądu o wpisie do rejestru przedsiębiorców Krajowego Rejestru Sądowego, zmiany umów spółek, przygotowywanie wewnętrznych aktów spółek, opiniowanie umów handlowych, doradztwo prawne na każdym etapie postępowania o udzielenie zamówienia publicznego, jak również na etapie realizacji zamówienia.\n\nPosiada szerokie doświadczenie w obsłudze jednostek samorządu terytorialnego (gmina, powiat), w tym reprezentacja przed sądami powszechnymi, opiniowanie umów samorządowych jednostek organizacyjnych, wydawanie opinii prawnych, uczestnictwo w sesjach organów stanowiących jednostek samorządu terytorialnego oraz opiniowanie uchwał tychże organów. Jej bogate doświadczenie zawodowe obejmuje ponadto reprezentację w spawach o ochronę dóbr osobistych oraz w sprawach z zakresu prawa prasowego.",
      "name": "Anna Samsik",
      "role": "Radca prawny · prawo pracy · prawo zobowiązań · prawo bankowe",
      "initials": "AS"
    }
  ],

  /* ------------------------------------------------------- jak to działa */
  howItWorks: {
    hero: {
      eyebrow: "Jak to działa",
      title: "Od pytania do podpisanego dokumentu",
      lead:
        "Cały proces prowadzisz z przeglądarki. Poniżej dokładnie opisujemy, co dzieje się na każdym etapie i ile to trwa.",
    },
    detailed: [
      {
        no: "01",
        t: "Wybierasz usługę i poznajesz cenę",
        d: "Decydujesz, czy potrzebujesz opinii prawnej (odpowiedź na pytanie), czy dokumentu (gotowy tekst do użycia). Przy każdej pozycji widnieje stała cena i deklarowany termin realizacji. Nic nie jest ukryte na późniejszym etapie.",
        detail: "Trwa: kilka minut",
      },
      {
        no: "02",
        t: "Opisujesz sprawę własnymi słowami",
        d: "Nie musisz znać terminologii ani przepisów. Podaj fakty, daty, kwoty i to, czego oczekujesz. Możesz wkleić treść umowy, korespondencji albo pisma, które otrzymałeś. Im więcej szczegółów, tym trafniejsza odpowiedź.",
        detail: "Trwa: 10–20 minut",
      },
      {
        no: "03",
        t: "Opłacasz sprawę i trafia ona do kolejki",
        d: "Płatność online uruchamia realizację — od tego momentu liczy się deklarowany termin. Sprawa dostaje numer, pod którym śledzisz ją w panelu klienta.",
        detail: "Trwa: chwilę",
      },
      {
        no: "04",
        t: "Prawnik przejmuje sprawę i opracowuje odpowiedź",
        d: "Sprawę przejmuje radca prawny ze specjalizacją odpowiadającą Twojemu problemowi. Ustala stan faktyczny, dobiera podstawy prawne i redaguje treść odpowiedzi tak, żeby dała się przeczytać bez znajomości prawa.",
        detail: "Trwa: większość czasu realizacji",
      },
      {
        no: "05",
        t: "Prawnik może dopytać o szczegóły",
        d: "Jeżeli w opisie brakuje czegoś istotnego, dostajesz pytanie w panelu. Odpowiedź wraca do prawnika, a termin realizacji zatrzymuje się na czas oczekiwania na Twoją odpowiedź.",
        detail: "Jeśli to konieczne",
      },
      {
        no: "06",
        t: "Odbierasz podpisany dokument",
        d: "Gotowa opinia lub dokument pojawia się w panelu jako PDF z pieczęcią prawly, imieniem, nazwiskiem i numerem wpisu prawnika. Dokument pobierasz i możesz go przedstawić drugiej stronie.",
        detail: "Trwa: natychmiast po podpisie",
      },
      {
        no: "07",
        t: "Możesz zadać pytanie uzupełniające",
        d: "Przy każdej zakończonej sprawie dostępne jest pytanie uzupełniające. Prawnik ocenia, czy mieści się ono w opłaconej usłudze. Jeżeli wymaga osobnej pracy, poda cenę zanim cokolwiek zacznie.",
        detail: "Bez limitu czasu",
      },
    ],
    compare: {
      eyebrow: "Opinia czy dokument",
      title: "Którą usługę wybrać",
      cols: [
        {
          t: "Opinia prawna",
          d: "Wybierz, gdy masz pytanie i nie wiesz, jak postąpić.",
          rows: [
            "Odpowiada na konkretne pytanie prawne",
            "Wskazuje podstawę prawną i jej praktyczne znaczenie",
            "Zawiera rekomendację następnego kroku",
            "Ocenia ryzyka i szanse przy każdym wariancie",
          ],
        },
        {
          t: "Dokument prawny",
          d: "Wybierz, gdy wiesz, co chcesz zrobić, i potrzebujesz tekstu.",
          rows: [
            "Gotowy do podpisania lub wysłania tekst",
            "Przygotowany według Twoich wytycznych i danych",
            "Umowy, wypowiedzenia, wezwania, reklamacje",
            "Zawiera instrukcję, jak i komu go doręczyć",
          ],
        },
      ],
    },
  },

  /* -------------------------------------------------------------- cennik */
  pricing: {
    hero: {
      eyebrow: "Cennik",
      title: "Jedna cena, zero niespodzianek",
      lead:
        "Płacisz raz, przed rozpoczęciem pracy. Cena obejmuje przygotowanie, weryfikację przez radcę prawnego, podpis i dokument w PDF.",
    },
    includedTitle: "W każdej cenie zawarte jest",
    included: [
      "Analiza opisanego przez Ciebie stanu faktycznego",
      "Wskazanie podstawy prawnej wraz z wyjaśnieniem",
      "Weryfikacja i redakcja przez radcę prawnego",
      "Podpis, numer wpisu i pieczęć na dokumencie PDF",
      "Pełna historia sprawy w panelu klienta",
      "Możliwość zadania pytania uzupełniającego",
    ],
    notIncludedTitle: "Czego cena nie obejmuje",
    notIncluded: [
      "Reprezentacji przed sądem i urzędem",
      "Opłat sądowych, skarbowych i notarialnych",
      "Prowadzenia negocjacji w Twoim imieniu",
      "Stałej obsługi prawnej firmy",
    ],
    faqTitle: "Pytania o płatności",
    faqIds: ["f5", "f6", "f7"],
  },

  /* ------------------------------------------------------------ kontakt */
  contact: {
    hero: {
      eyebrow: "Kontakt",
      title: "Napisz do nas",
      lead:
        "Odpowiadamy w dni robocze, zwykle tego samego dnia. Jeżeli masz konkretną sprawę do opracowania, szybciej będzie założyć ją bezpośrednio w panelu.",
    },
    note:
      "Uwaga: formularz kontaktowy służy do pytań o działanie serwisu. Nie udzielamy przez niego porad prawnych — te realizujemy wyłącznie jako opłacone sprawy, żeby prawnik mógł wziąć za nie odpowiedzialność.",
    topics: [
      "Pytanie o działanie serwisu",
      "Faktura i płatności",
      "Współpraca dla prawników",
      "Media i partnerstwa",
      "Inne",
    ],
  },

  /* ---------------------------------------------------------------- FAQ */
  /* Strony docelowe z reklam — edytowane w /admin/landingi, patrz landing/Landing.jsx. */
  landings: LANDINGS,
  /* Treści wspólne stron docelowych: przykładowa opinia, radca, ryzyko płatności, poufność — /admin/landingi-wspolne. */
  landingShared: LANDING_SHARED,
  /* Opinie z wizytówki Google kancelarii OLC (wpisywane ręcznie, max 5) — /admin/opinie-google. */
  googleReviews: GOOGLE_REVIEWS,

  faq: [
    {
      id: "f1",
      cat: "Usługa",
      q: "Czym różni się opinia od dokumentu?",
      a: "Opinia odpowiada na Twoje pytanie prawne i wskazuje, co zrobić. Dokument to gotowy do użycia tekst — np. umowa sprzedaży samochodu, wypowiedzenie czy wezwanie do zapłaty — przygotowany według Twoich wytycznych.",
    },
    {
      id: "f2",
      cat: "Usługa",
      q: "Czy mogę dopytać po otrzymaniu odpowiedzi?",
      a: "Tak. Przy każdej zakończonej sprawie możesz zadać pytanie uzupełniające. Prawnik oceni, czy mieści się ono w opłaconej usłudze, czy wymaga dopłaty — o kwocie zdecyduje przed rozpoczęciem pracy.",
    },
    {
      id: "f3",
      cat: "Odpowiedzialność",
      q: "Kto odpowiada za treść?",
      a: "Każdą odpowiedź podpisuje imieniem, nazwiskiem i numerem wpisu konkretny radca prawny. Podpis i identyfikator znajdziesz na dokumencie PDF i w historii sprawy. To prawnik ponosi odpowiedzialność zawodową za treść.",
    },
    {
      id: "f4",
      cat: "Odpowiedzialność",
      q: "Kto przygotowuje odpowiedź na moją sprawę?",
      a: "Radca prawny ze specjalizacją odpowiadającą Twojemu problemowi. Ta sama osoba analizuje stan faktyczny, dobiera podstawy prawne, redaguje treść i podpisuje dokument swoim imieniem, nazwiskiem oraz numerem wpisu. Jej dane widzisz w historii sprawy od chwili przejęcia sprawy.",
    },
    {
      id: "f5",
      cat: "Płatności",
      q: "Kiedy płacę i czy cena może się zmienić?",
      a: "Płacisz przed rozpoczęciem pracy, a cena widoczna przy zamówieniu jest ceną ostateczną dla tej usługi. Dopłata może pojawić się tylko wtedy, gdy sam zlecisz dodatkową pracę wykraczającą poza usługę — i zawsze poznasz kwotę wcześniej.",
    },
    {
      id: "f6",
      cat: "Płatności",
      q: "Czy dostanę fakturę?",
      a: "Tak. Fakturę wystawiamy automatycznie po opłaceniu sprawy. Jeżeli potrzebujesz faktury na firmę, podaj dane przy zakładaniu sprawy — znajdziesz je później w panelu klienta.",
    },
    {
      id: "f7",
      cat: "Płatności",
      q: "Co jeśli sprawa okaże się niemożliwa do opracowania?",
      a: "Jeżeli po analizie okaże się, że sprawa wykracza poza zakres usługi albo wymaga reprezentacji procesowej, poinformujemy Cię o tym i zwrócimy pełną kwotę. Nie pobieramy opłaty za odmowę.",
    },
    {
      id: "f8",
      cat: "Terminy",
      q: "Od kiedy liczy się termin realizacji?",
      a: "Od momentu zaksięgowania płatności. Termin wynosi 12 godzin roboczych dla opinii i dokumentu oraz 24 godziny robocze dla pakietu (opinia + dokument). Jeżeli prawnik zada Ci pytanie uzupełniające, termin zatrzymuje się do chwili Twojej odpowiedzi.",
    },
    {
      id: "f9",
      cat: "Terminy",
      q: "Ile trwa opracowanie sprawy?",
      a: "Opinię albo dokument opracowujemy w ciągu 12 godzin roboczych od zaksięgowania płatności, a pakiet (opinia + dokument) w ciągu 24 godzin roboczych. Termin wybranej usługi widzisz przed zamówieniem. Jeżeli sprawa okaże się na tyle złożona, że rzetelna analiza wymaga więcej czasu, poinformujemy Cię o tym przed rozpoczęciem pracy i możesz wtedy odstąpić od zlecenia.",
    },
    {
      id: "f10",
      cat: "Dane",
      q: "Co dzieje się z moimi danymi?",
      a: "Opis sprawy i załączone materiały widzi wyłącznie prawnik prowadzący sprawę. Dane przetwarzamy zgodnie z RODO, a szczegóły opisaliśmy w polityce prywatności. Historia sprawy pozostaje dostępna w Twoim panelu do czasu, aż zażądasz jej usunięcia.",
    },
  ],

  /* --------------------------------------- flagi robocze spraw (panel prawnika) */
  caseFlags: [
    { id: "trudna", label: "Trudna", color: "#c0392b" },
    { id: "wzorcowa", label: "Wzorcowa", color: "#1e8a5f" },
    { id: "pilne", label: "Pilne", color: "#b8860b" },
  ],

  /* ------------------------------------------- maile transakcyjne (panel) */
  emailTemplates: {
    contact_form: {
      label: "Formularz kontaktowy → biuro",
      enabled: true,
      subject: "Nowa wiadomość z formularza kontaktowego: {{topic}}",
      body: "Nowa wiadomość ze strony prawly.pl.\n\nOd: {{name}} ({{email}})\nTemat: {{topic}}\n\n{{message}}",
    },
    quick_lead: {
      label: "Wstępny opis z chorągiewki → biuro",
      enabled: true,
      subject: "Ktoś uzupełnił wstępny temat porady na stronie",
      body: "Ktoś na stronie prawly.pl uzupełnił wstępny opis sprawy (jeszcze przed założeniem zamówienia i podaniem danych kontaktowych):\n\n\"{{description}}\"\n\nTo tylko wstępny opis z formularza na stronie głównej — nie ma jeszcze konta ani złożonego zamówienia.",
    },
    register_welcome: {
      label: "Powitanie po rejestracji",
      enabled: true,
      subject: "Witamy w prawly",
      body: "Dzień dobry,\n\nPaństwa konto w prawly zostało założone. Mogą Państwo teraz opisać swoją sprawę i zamówić opinię prawną albo dokument — odpowiedź przygotuje i podpisze radca prawny.\n\nZapraszamy do panelu klienta.",
    },
    case_paid: {
      label: "Potwierdzenie zamówienia (po opłaceniu)",
      enabled: true,
      subject: "Potwierdzenie zamówienia — sprawa {{case_no}}",
      body: "Dzień dobry,\n\nDziękujemy za zamówienie usługi „{{service_name}}” (sprawa {{case_no}}). Płatność {{price}} została zaksięgowana — prawnik już nad nią pracuje.\n\nStatus sprawy mogą Państwo śledzić tutaj: {{case_url}}",
    },
    case_delivered: {
      label: "Sprawa gotowa (podpisana odpowiedź)",
      enabled: true,
      subject: "Sprawa {{case_no}} jest gotowa",
      body: "Dzień dobry,\n\nOdpowiedź w sprawie „{{title}}” ({{case_no}}) jest już gotowa i podpisana przez prawnika.\n\nDo pobrania tutaj: {{case_url}}",
    },
    followup_decision: {
      label: "Decyzja w sprawie pytania uzupełniającego",
      enabled: true,
      subject: "Odpowiedź w sprawie pytania uzupełniającego — {{case_no}}",
      body: "Dzień dobry,\n\nW sprawie {{case_no}} Państwa pytanie uzupełniające zostanie opracowane {{decision_text}}.\n\nSzczegóły są dostępne tutaj: {{case_url}}",
    },
    case_supplemented: {
      label: "Uzupełnienie sprawy przez prawnika",
      enabled: true,
      subject: "Uzupełnienie sprawy {{case_no}}",
      body: "Dzień dobry,\n\nPrawnik uzupełnił sprawę {{case_no}} o dodatkowe informacje:\n\n{{message}}\n\nSzczegóły są dostępne tutaj: {{case_url}}",
    },
    lawyer_account_created: {
      label: "Nowe konto prawnika (hasło tymczasowe)",
      enabled: true,
      subject: "Konto w panelu prawly zostało utworzone",
      body: "Dzień dobry {{full_name}},\n\nAdministrator utworzył dla Państwa konto prawnika w panelu prawly.\n\nLogin: {{email}}\nHasło tymczasowe: {{temp_password}}\n\nProsimy o zalogowanie się i jak najszybszą zmianę hasła: {{login_url}}",
    },
    admin_account_created: {
      label: "Nowe konto administratora (hasło tymczasowe)",
      enabled: true,
      subject: "Konto administratora w panelu prawly zostało utworzone",
      body: "Dzień dobry {{full_name}},\n\nUtworzono dla Państwa konto administratora w panelu prawly.\n\nLogin: {{email}}\nHasło tymczasowe: {{temp_password}}\n\nProsimy o zalogowanie się i jak najszybszą zmianę hasła: {{login_url}}",
    },
    case_ready_lawyers: {
      label: "Nowa sprawa gotowa do przejęcia (do wszystkich prawników)",
      enabled: true,
      subject: "Nowa sprawa gotowa do przejęcia: {{case_no}}",
      body: "Dzień dobry,\n\nAI przygotowało już szkic odpowiedzi dla nowej sprawy — jest gotowa do przejęcia.\n\nSprawa: {{case_no}}\nKategoria: {{category}}\nTemat: {{title}}\n\nProsimy o przejęcie sprawy w kolejce: {{queue_url}}",
    },
    sla_reminder: {
      label: "Przypomnienie: zbliża się termin SLA",
      enabled: true,
      subject: "Zostało {{hours_left}} godz. na sprawę {{case_no}}",
      body: "Dzień dobry {{lawyer_name}},\n\nDo terminu realizacji sprawy {{case_no}} („{{title}}”) zostało około {{hours_left}} godz.\n\nSprawa w panelu: {{case_url}}",
    },
    daily_digest: {
      label: "Poranny przegląd dnia (dla prawnika)",
      enabled: true,
      subject: "Przegląd dnia w prawly",
      body: "Dzień dobry {{lawyer_name}},\n\nSprawy w toku prowadzone przez Państwa:\n{{own_cases_list}}\n\nDziś mija termin dla {{today_count}} z nich.\n\nW ogólnej kolejce czeka też {{queue_count}} spraw gotowych do przejęcia: {{queue_url}}\n\nRozmowy na czacie czekające na odpowiedź: {{chat_count}} — {{chat_url}}\n\nArchiwum wszystkich spraw: {{archive_url}}",
    },
    surcharge_requested: {
      label: "Prośba o dopłatę w trakcie opracowania",
      enabled: true,
      subject: "Sprawa {{case_no}} — prośba o dopłatę",
      body: "Dzień dobry,\n\nW trakcie pracy nad sprawą {{case_no}} okazało się, że wymaga ona dodatkowego nakładu pracy.\n\nProsimy o dopłatę {{amount}}. Powód: {{reason}}\n\nSzczegóły i płatność są dostępne w panelu sprawy: {{case_url}}",
    },
    surcharge_expired: {
      label: "Wygaśnięcie prośby o dopłatę (po 14 dniach)",
      enabled: true,
      subject: "Sprawa {{case_no}} — prośba o dopłatę wygasła",
      body: "Dzień dobry,\n\nProśba o dopłatę {{amount}} w sprawie {{case_no}} wygasła, ponieważ dopłata nie została opłacona w ciągu 14 dni.\n\n{{outcome}}\n\nJeżeli nadal zależy Państwu na dodatkowym opracowaniu, prosimy o wiadomość w panelu sprawy — przygotujemy nową propozycję.\n\nSzczegóły sprawy: {{case_url}}",
    },
    surcharge_cancelled: {
      label: "Wycofanie prośby o dopłatę",
      enabled: true,
      subject: "Sprawa {{case_no}} — prośba o dopłatę wycofana",
      body: "Dzień dobry,\n\nProśba o dopłatę {{amount}} w sprawie {{case_no}} została wycofana — opłacanie dopłaty nie jest już potrzebne.\n\n{{outcome}}\n\nJeżeli chcą Państwo zadać pytanie albo zlecić dodatkowe opracowanie, prosimy o wiadomość w panelu sprawy.\n\nSzczegóły sprawy: {{case_url}}",
    },
    case_declined_cannot_handle: {
      label: "Odmowa — nie możemy obsłużyć sprawy",
      enabled: true,
      subject: "Sprawa {{case_no}} — nie możemy jej obsłużyć",
      body: "Dzień dobry,\n\nZ przykrością informujemy, że nie możemy obsłużyć Państwa sprawy {{case_no}}.\n\nProsimy o podanie numeru rachunku bankowego, na który zwrócimy wpłatę — mogą to Państwo zrobić bezpośrednio w panelu sprawy: {{case_url}}",
    },
    payment_reminder: {
      label: "Przypomnienie o nieopłaconym zamówieniu → klient",
      enabled: true,
      subject: "Przypomnienie o płatności — sprawa {{case_no}}",
      body: "Dzień dobry,\n\nPrzypominamy, że Państwa zamówienie {{case_no}} nadal oczekuje na płatność ({{amount}}). Pracę nad sprawą rozpoczynamy dopiero po zaksięgowaniu wpłaty.\n\nJeżeli wystąpiły jakieś problemy z płatnością, prosimy o kontakt — chętnie pomożemy.\n\nSzczegóły zamówienia: {{case_url}}",
    },
    review_request: {
      label: "Prośba o opinię w Google (3 dni po realizacji) → klient",
      enabled: true,
      subject: "Jak oceniają Państwo pomoc prawly? Będziemy wdzięczni za opinię",
      body: "Dzień dobry,\n\nkilka dni temu dostarczyliśmy Państwu wynik sprawy {{case_no}}.\n\nJeżeli mają Państwo chwilę, będziemy wdzięczni za krótką opinię w Google — dzięki niej inni mogą łatwiej ocenić, czy możemy pomóc także im:\n\n{{review_url}}\n\nZajmie to około minuty. Dziękujemy!",
    },
    chat_new_message: {
      label: "Nowa wiadomość na czacie → administratorzy",
      enabled: true,
      subject: "Nowa wiadomość na czacie prawly — {{visitor}}",
      body: "Ktoś napisał na czacie na stronie prawly.pl.\n\nOd: {{visitor}}\nE-mail: {{visitor_email}}\n\n\"{{message}}\"\n\nOdpowiedź w panelu: {{chat_url}}\n\n(Kolejne wiadomości z tej rozmowy w ciągu kilku minut nie generują osobnych maili.)",
    },
    chat_reply_visitor: {
      label: "Odpowiedź z czatu, gdy odwiedzającego nie ma w oknie → odwiedzający",
      enabled: true,
      subject: "Odpowiedź od zespołu prawly",
      body: "Dzień dobry,\n\nodpowiadamy na Państwa wiadomość z czatu na prawly.pl:\n\n\"{{message}}\"\n\nMogą Państwo wrócić do rozmowy i odpisać tutaj: {{chat_url}}",
    },
    custom_order_created: {
      label: "Zamówienie indywidualne do opłacenia → klient",
      enabled: true,
      subject: "Zamówienie do opłacenia — {{title}}",
      body: "Dzień dobry,\n\nprzygotowaliśmy dla Państwa zamówienie indywidualne: „{{title}}” (sprawa {{case_no}}). Cena: {{amount}}.\n\nProsimy o zapoznanie się z zakresem usługi, akceptację warunków i płatność pod tym adresem:\n\n{{order_url}}\n\nPo zaksięgowaniu płatności rozpoczniemy realizację, a wszystkie ustalenia i dokumenty będą przekazywane w panelu sprawy.",
    },
    custom_message_client: {
      label: "Nowa wiadomość prawnika w sprawie → klient",
      enabled: true,
      subject: "Nowa wiadomość w sprawie {{case_no}}",
      body: "Dzień dobry,\n\nw sprawie {{case_no}} pojawiła się nowa wiadomość od prawnika. Prosimy o zapoznanie się z nią i ewentualną odpowiedź w panelu sprawy:\n\n{{case_url}}\n\n(Kolejne wiadomości z tej sprawy w ciągu kilku minut nie generują osobnych maili.)",
    },
    custom_completed: {
      label: "Zakończenie sprawy indywidualnej → klient",
      enabled: true,
      subject: "Realizacja sprawy {{case_no}} została zakończona",
      body: "Dzień dobry,\n\nwszystkie uzgodnione czynności w sprawie „{{title}}” ({{case_no}}) zostały wykonane. Historię wiadomości i przekazane pliki mogą Państwo zobaczyć w panelu sprawy:\n\n{{case_url}}\n\nJeżeli mają Państwo dodatkowe pytania, prosimy zadać je w panelu sprawy — prawnik oceni i odpowie.",
    },
    case_paid_free: {
      label: "Zamówienie przyjęte bez opłaty (kod 100%) → klient",
      enabled: true,
      subject: "Zamówienie przyjęte — sprawa {{case_no}}",
      body: "Dzień dobry,\n\ndziękujemy za zamówienie usługi „{{service_name}}” (sprawa {{case_no}}). Zamówienie zostało przyjęte do realizacji bez opłaty (kod rabatowy: {{discount_code}}) — prawnik już nad nim pracuje.\n\nStatus sprawy mogą Państwo śledzić tutaj: {{case_url}}",
    },
    legal_docs_updated: {
      label: "Zmiana Regulaminu/Polityki → wymaga ponownej akceptacji",
      enabled: true,
      subject: "Zaktualizowaliśmy {{doc_title}}",
      body: "Dzień dobry,\n\nZaktualizowaliśmy {{doc_title}} serwisu prawly. Prosimy o zapoznanie się z nową treścią i potwierdzenie przy najbliższym logowaniu:\n\n{{doc_url}}\n\nBez tego nie będzie można dalej korzystać z konta.",
    },
    case_declined_too_complex: {
      label: "Odmowa — sprawa zbyt złożona",
      enabled: true,
      subject: "Sprawa {{case_no}} — prosimy o kontakt",
      body: "Dzień dobry,\n\nSprawa {{case_no}} jest zbyt złożona i wymaga bardzo dokładnej analizy (dokumenty, spotkanie itd.).\n\nProsimy o kontakt pod numerem telefonu 71 307 50 57. Jeżeli nie chcą Państwo z niego skorzystać, prosimy o podanie numeru rachunku bankowego, na który zwrócimy wpłatę — mogą to Państwo zrobić bezpośrednio w panelu sprawy: {{case_url}}",
    },
    refund_account_provided: {
      label: "Biuro — klient podał numer konta do zwrotu",
      enabled: true,
      subject: "Zwrot do zrealizowania — {{case_no}}",
      body: "Klient {{client_name}} podał numer konta do zwrotu w sprawie {{case_no}}:\n\n{{account_number}}\n\nProszę zrealizować zwrot ręcznie.",
    },
    case_transferred: {
      label: "Sprawa przekazana innemu prawnikowi",
      enabled: true,
      subject: "Sprawa {{case_no}} została Państwu przekazana",
      body: "Dzień dobry,\n\nSprawa {{case_no}} — {{title}} — została Państwu przekazana do dalszego prowadzenia.\n\nSzczegóły: {{case_url}}",
    },
    ai_generation_truncated: {
      label: "Biuro — generowanie AI zostało ucięte",
      enabled: true,
      subject: "Uwaga: generowanie AI ucięte — {{case_no}}",
      body: "Generowanie projektu w sprawie {{case_no}} — {{title}} ({{category}}) — nie zmieściło się w limicie długości nawet po dodatkowych próbach kontynuacji.\n\nSprawa ma status \"Wymaga uwagi\" — proszę sprawdzić w kolejce i wygenerować szkic ponownie: {{queue_url}}",
    },
    password_reset: {
      label: "Resetowanie hasła",
      enabled: true,
      subject: "Resetowanie hasła w prawly",
      body: "Dzień dobry,\n\nOtrzymaliśmy prośbę o zresetowanie hasła do Państwa konta w prawly. Prosimy kliknąć poniższy link, aby ustawić nowe hasło (link jest ważny przez godzinę):\n\n{{reset_url}}\n\nJeżeli to nie Państwo prosili o reset hasła, prosimy zignorować tę wiadomość — hasło pozostanie bez zmian.",
    },
    email_changed: {
      label: "Zmiana adresu e-mail na koncie",
      enabled: true,
      subject: "Zmieniono adres e-mail na koncie w prawly",
      body: "Dzień dobry,\n\nAdres e-mail logowania do Państwa konta w prawly został zmieniony na: {{new_email}}\n\nJeżeli to nie Państwo dokonali tej zmiany, prosimy o jak najszybszy kontakt z nami — biuro@prawly.pl.",
    },
    followup_answered: {
      label: "Szybka odpowiedź na pytanie uzupełniające (bez zmiany dokumentu)",
      enabled: true,
      subject: "Odpowiedź na pytanie uzupełniające — {{case_no}}",
      body: "Dzień dobry,\n\nPrawnik odpowiedział na Państwa pytanie w sprawie {{case_no}}:\n\n{{answer}}\n\nSzczegóły i historia sprawy są dostępne tutaj: {{case_url}}",
    },
    status_in_review: {
      label: "Zmiana statusu: sprawa wróciła do opracowania → klient",
      enabled: true,
      subject: "Sprawa {{case_no}} — wróciła do opracowania",
      body: "Dzień dobry,\n\nInformujemy, że sprawa {{case_no}} wróciła do etapu opracowania — prawnik prowadzący ponownie zajmuje się Państwa sprawą. O dalszych krokach poinformujemy Państwa w panelu.\n\nHistoria sprawy jest dostępna tutaj: {{case_url}}",
    },
    status_delivered: {
      label: "Zmiana statusu: sprawa ma status Gotowe → klient",
      enabled: true,
      subject: "Sprawa {{case_no}} — status: Gotowe",
      body: "Dzień dobry,\n\nInformujemy, że sprawa {{case_no}} ma status „Gotowe”. Wynik oraz pełną historię sprawy mogą Państwo w każdej chwili sprawdzić tutaj: {{case_url}}",
    },
    invoice_failed: {
      label: "Biuro — nie udało się wystawić faktury w iFirma",
      enabled: true,
      subject: "Uwaga: faktura nie została wystawiona — {{case_no}}",
      body: "Płatność ({{payment_kind}}, {{amount}}) w sprawie {{case_no}} została potwierdzona, ale automatyczne wystawienie faktury w iFirma nie powiodło się.\n\nBłąd: {{error}}\n\nFakturę trzeba wystawić ręcznie z panelu iFirma.",
    },
    document_reminder: {
      label: "Przypomnienie po dobie: czy zlecić sporządzenie dokumentu (rekomendacja z opinii) → klient",
      enabled: true,
      subject: "Sprawa {{case_no}} — czy zlecić sporządzenie dokumentu?",
      body: "Dzień dobry,\n\nW opinii w sprawie {{case_no}} („{{title}}”) zarekomendowaliśmy przygotowanie dokumentu prawnego. Dobrze sporządzone pismo utrwala stanowisko na piśmie i porządkuje dalsze działania.\n\nCzy chcą Państwo zlecić sporządzenie dokumentu?\n\n[[przycisk: Tak, zamawiam dokument | {{order_url}}]]\n[[przycisk-jasny: Nie, rezygnuję z dokumentu | {{decline_url}}]]\n\nPrzycisk „Tak” otwiera formularz zamówienia wypełniony odniesieniem do sprawy {{case_no}}. Jeżeli mają Państwo pytania, prosimy o odpowiedź na tę wiadomość.",
    },
    document_declined: {
      label: "Biuro — klient zrezygnował z zarekomendowanego dokumentu",
      enabled: true,
      subject: "Rezygnacja z dokumentu — sprawa {{case_no}}",
      body: "Klient {{client_name}} ({{client_email}}) zrezygnował z zamówienia dokumentu zarekomendowanego w opinii w sprawie {{case_no}} („{{title}}”).\n\nKlient nie zamówił dokumentu w ciągu doby od dostarczenia opinii i w odpowiedzi na przypomnienie wybrał „Nie”.\n\nSprawa: {{case_url}}",
    },
  },

  /* Godziny pracy, wg których liczony jest termin realizacji (Regulamin
     § 9 — "24 Godziny Robocze"). Domyślne extraOff to realne polskie dni
     ustawowo wolne na 2026 rok (Poniedziałek Wielkanocny i Boże Ciało
     policzone z daty Wielkanocy, nie zgadywane) — w pełni edytowalne
     z panelu /admin/ustawienia. */
  businessHours: {
    days: {
      mon: { open: true, start: "09:00", end: "17:00" },
      tue: { open: true, start: "09:00", end: "17:00" },
      wed: { open: true, start: "09:00", end: "17:00" },
      thu: { open: true, start: "09:00", end: "17:00" },
      fri: { open: true, start: "09:00", end: "17:00" },
      sat: { open: false, start: "09:00", end: "17:00" },
      sun: { open: false, start: "09:00", end: "17:00" },
    },
    extraOff: [
      "2026-01-01", "2026-01-06", "2026-04-06", "2026-05-01",
      "2026-05-03", "2026-05-24", "2026-06-04", "2026-08-15",
      "2026-11-01", "2026-11-11", "2026-12-25", "2026-12-26",
    ],
  },

  /* --------------------------------------------------------- baza wiedzy */
  posts: [
    {
      id: "p1",
      slug: "wezwanie-do-zaplaty-jak-napisac",
      title: "Wezwanie do zapłaty — jak je napisać, żeby zadziałało",
      excerpt:
        "Skuteczne wezwanie to nie kwestia ostrego tonu, lecz czterech elementów, których brak najczęściej przesądza o tym, że pismo trafia do kosza.",
      cat: "Windykacja",
      author: "Michał Baranowski",
      date: "2026-07-14",
      readMin: 6,
      published: true,
      body: `Wezwanie do zapłaty jest najtańszym narzędziem, jakie masz do dyspozycji, zanim sprawa trafi do sądu. Jednocześnie jest to pismo, które najczęściej pisze się źle — bo wydaje się proste.

## Cztery elementy, bez których wezwanie nie działa

Pismo musi jednoznacznie identyfikować **wierzytelność**: z czego wynika, kiedy powstała i ile dokładnie wynosi. Ogólnik w rodzaju "za wykonane usługi" pozwala dłużnikowi udawać, że nie wie, o co chodzi.

- **Podstawa** — numer faktury, data umowy, opis świadczenia.
- **Kwota** — należność główna i odsetki wyliczone osobno.
- **Termin** — konkretna data, nie "niezwłocznie".
- **Skutek** — co zrobisz po upływie terminu.

> Wezwanie bez wskazanego terminu i skutku jest w praktyce przypomnieniem, a nie wezwaniem. Dłużnik czyta je dokładnie tak, jak zostało napisane.

## Dlaczego data ma znaczenie prawne

Od dnia następującego po upływie terminu wskazanego w wezwaniu naliczasz odsetki ustawowe za opóźnienie. Jeżeli termin nie został wyznaczony, moment wymagalności trzeba dopiero wykazać — a to komplikuje pozew.

## Jak doręczyć

Najbezpieczniej listem poleconym za potwierdzeniem odbioru, na adres z rejestru. E-mail bywa wystarczający, jeżeli strony wcześniej korespondowały tą drogą, ale w razie sporu to Ty wykazujesz, że wiadomość dotarła.

## Kiedy przestać wzywać

Drugie wezwanie ma sens. Trzecie i czwarte pokazują tylko, że nie zamierzasz iść dalej — i dłużnik to odczyta. Jeżeli po dwóch pismach nie ma reakcji ani propozycji ugody, kolejnym krokiem jest pozew albo postępowanie upominawcze.`,
    },
    {
      id: "p2",
      slug: "wypowiedzenie-umowy-o-prace-terminy",
      title: "Wypowiedzenie umowy o pracę: terminy, których nie da się skrócić",
      excerpt:
        "Okres wypowiedzenia liczy się inaczej, niż podpowiada intuicja. Różnica bywa warta kilku tysięcy złotych.",
      cat: "Prawo pracy",
      author: "Katarzyna Zielińska",
      date: "2026-06-28",
      readMin: 5,
      published: true,
      body: `Najczęstszy błąd przy wypowiedzeniu nie dotyczy jego treści, tylko liczenia czasu. Okres wypowiedzenia liczony w miesiącach kończy się w ostatnim dniu miesiąca kalendarzowego — nie po trzydziestu dniach od złożenia pisma.

## Jak liczyć okres wypowiedzenia

Przy wypowiedzeniu liczonym w miesiącach bieg rozpoczyna się pierwszego dnia miesiąca następującego po tym, w którym złożono oświadczenie.

- Wypowiedzenie złożone 3 marca przy okresie jednomiesięcznym kończy stosunek pracy **30 kwietnia**.
- Wypowiedzenie złożone 30 marca kończy go **również 30 kwietnia**.

Ta sama data przy różnicy dwudziestu siedmiu dni bywa zaskoczeniem dla obu stron.

## Okresy zależą od stażu, nie od rodzaju umowy

Od 2016 roku umowa na czas określony i nieokreślony mają identyczne okresy wypowiedzenia:

- **2 tygodnie** — staż krótszy niż 6 miesięcy,
- **1 miesiąc** — staż co najmniej 6 miesięcy,
- **3 miesiące** — staż co najmniej 3 lata.

Liczy się łączny okres zatrudnienia u tego pracodawcy, także z przerwami.

## Czego nie da się zmienić umową

Strony mogą wydłużyć okres wypowiedzenia, ale nie mogą go skrócić poniżej ustawowego minimum. Postanowienie mniej korzystne dla pracownika jest nieważne — w jego miejsce wchodzi przepis kodeksu.

> Wyjątkiem jest porozumienie stron zawarte już po złożeniu wypowiedzenia. Wtedy można ustalić wcześniejszą datę rozwiązania, a okres wypowiedzenia i tak zachowuje skutki dla świadectwa pracy.`,
    },
    {
      id: "p3",
      slug: "rekojmia-a-gwarancja-roznice",
      title: "Rękojmia a gwarancja — dwa różne uprawnienia, nie synonimy",
      excerpt:
        "Sprzedawca odsyła do producenta, producent do sprzedawcy. Znajomość różnicy kończy tę wymianę w jednym zdaniu.",
      cat: "Prawo konsumenckie",
      author: "Michał Baranowski",
      date: "2026-05-19",
      readMin: 4,
      published: true,
      body: `Rękojmia i gwarancja to dwa niezależne reżimy odpowiedzialności. Możesz korzystać z obu, wybierając ten, który jest w danej chwili korzystniejszy — i nikt nie może narzucić Ci wyboru.

## Rękojmia

Wynika **z ustawy** i przysługuje zawsze, niezależnie od tego, czy sprzedawca ją deklaruje. Odpowiada za nią sprzedawca, a nie producent. Trwa co do zasady dwa lata od wydania rzeczy.

W ramach rękojmi możesz żądać naprawy, wymiany, obniżenia ceny albo odstąpienia od umowy.

## Gwarancja

Jest **dobrowolna**. Udziela jej producent lub sprzedawca i sam ustala jej warunki w karcie gwarancyjnej. Może trwać dłużej niż rękojmia, ale może też obejmować mniej.

> Zdanie, które kończy dyskusję w sklepie: "Korzystam z rękojmi, nie z gwarancji — kieruję roszczenie do sprzedawcy."

## Co zrobić, gdy sprzedawca odmawia

Reklamację składaj na piśmie i zachowaj dowód nadania. Brak odpowiedzi w ciągu czternastu dni przy reklamacji z rękojmi oznacza jej uznanie — to bardzo mocny argument w dalszym sporze.`,
    },
    {
      id: "p4",
      slug: "umowa-najmu-na-co-uwazac",
      title: "Umowa najmu mieszkania: siedem zapisów, które warto sprawdzić",
      excerpt:
        "Kaucja, waloryzacja czynszu i tryb wypowiedzenia — trzy miejsca, w których najczęściej kryje się problem.",
      cat: "Nieruchomości",
      author: "Paweł Grabowski",
      date: "2026-04-08",
      readMin: 7,
      published: true,
      body: `Umowa najmu bywa podpisywana w pośpiechu, przy kluczach na stole. Poniżej lista miejsc, w które warto zajrzeć, zanim to nastąpi.

## 1. Wysokość i zasady zwrotu kaucji

Kaucja nie może przekraczać dwunastokrotności czynszu. Umowa powinna określać **termin zwrotu** — bez niego spór o kaucję zaczyna się dopiero po wyprowadzce.

## 2. Waloryzacja czynszu

Zapis "wynajmujący może podnieść czynsz" bez wskazania trybu i limitu jest w praktyce blankietowy. Sprawdź, czy jest tam okres wypowiedzenia zmiany i jej maksymalna wysokość.

## 3. Tryb wypowiedzenia

Przy najmie na czas określony wypowiedzenie jest możliwe tylko wtedy, gdy umowa wprost je przewiduje. Brak takiego zapisu wiąże obie strony do końca okresu.

## 4. Protokół zdawczo-odbiorczy

Bez niego stan lokalu przy wydaniu jest kwestią słowa przeciwko słowu. Zdjęcia z datą są dobrym uzupełnieniem, ale nie zastępują podpisanego protokołu.

## 5. Opłaty niezależne od wynajmującego

Umowa powinna rozdzielać czynsz najmu od opłat eksploatacyjnych i mediów. Kwota "wszystko w cenie" utrudnia późniejsze rozliczenie.

## 6. Zgoda na podnajem i zameldowanie

Standardowo podnajem wymaga zgody. Zameldowanie to czynność administracyjna, której wynajmujący nie może skutecznie zakazać — ale może to być źródłem sporu, więc lepiej uregulować to wprost.

## 7. Najem okazjonalny

Jeżeli umowa jest najmem okazjonalnym, wymaga aktu notarialnego o poddaniu się egzekucji i zgłoszenia do urzędu skarbowego w ciągu czternastu dni. Bez tego traci swoje szczególne skutki.`,
    },
    {
      id: "p5",
      slug: "co-zrobic-z-nakazem-zaplaty",
      title: "Dostałeś nakaz zapłaty. Masz dwa tygodnie i trzy możliwości",
      excerpt:
        "Nakaz z sądu nie jest wyrokiem, ale staje się nim po upływie terminu na sprzeciw. Ten termin jest nieprzywracalny w praktyce.",
      cat: "Postępowanie",
      author: "Alicja Nowicka",
      date: "2026-03-02",
      readMin: 5,
      published: true,
      body: `Nakaz zapłaty wydany w postępowaniu upominawczym albo nakazowym to rozstrzygnięcie wydane bez Twojego udziału, wyłącznie na podstawie twierdzeń powoda. Prawo daje Ci na reakcję dwa tygodnie od doręczenia.

## Trzy możliwe reakcje

- **Zapłacić** — jeżeli roszczenie jest zasadne, zapłata w terminie kończy sprawę i ogranicza koszty.
- **Wnieść sprzeciw lub zarzuty** — nakaz traci moc w całości albo w części, a sprawa trafia na rozprawę.
- **Nie zrobić nic** — nakaz uprawomocni się i stanie się tytułem wykonawczym.

> Trzecia opcja jest wyborem, nawet jeśli nie wydaje się decyzją. Po uprawomocnieniu obrona merytoryczna jest w zasadzie zamknięta.

## Czego nie wolno pominąć w sprzeciwie

Sprzeciw musi zawierać zarzuty i wnioski dowodowe. Późniejsze ich zgłaszanie bywa pomijane jako spóźnione. Warto wskazać wszystko od razu, nawet jeśli wydaje się oczywiste.

## Kiedy termin nie biegnie prawidłowo

Jeżeli nakaz został doręczony na nieaktualny adres i faktycznie go nie odebrałeś, można wnioskować o przywrócenie terminu — ale trzeba to zrobić w ciągu tygodnia od ustania przeszkody i uprawdopodobnić brak winy.`,
    },
    {
      id: "p6",
      slug: "alimenty-jak-ustala-sie-wysokosc",
      title: "Alimenty: od czego naprawdę zależy ich wysokość",
      excerpt:
        "Sąd nie stosuje tabeli ani procentu od dochodu. Liczą się dwie wielkości i sposób, w jaki się je udokumentuje.",
      cat: "Prawo rodzinne",
      author: "Alicja Nowicka",
      date: "2026-01-21",
      readMin: 6,
      published: true,
      body: `W sprawach alimentacyjnych najczęstsze oczekiwanie brzmi: ile procent zarobków. Takiego przelicznika nie ma. Sąd bada dwie rzeczy — usprawiedliwione potrzeby uprawnionego oraz zarobkowe i majątkowe możliwości zobowiązanego.

## Usprawiedliwione potrzeby

To nie jest minimum egzystencji ani lista wydatków z paragonów. Chodzi o poziom życia odpowiadający wiekowi, stanowi zdrowia i uzasadnionym zainteresowaniom dziecka.

Zestawienie miesięcznych kosztów warto przygotować pozycjami: mieszkanie w części przypadającej na dziecko, wyżywienie, odzież, leczenie, edukacja, zajęcia dodatkowe.

## Możliwości zobowiązanego

Kluczowe słowo to **możliwości**, nie faktyczne dochody. Jeżeli ktoś świadomie rezygnuje z lepiej płatnej pracy albo ukrywa dochody, sąd bierze pod uwagę to, ile mógłby zarabiać przy pełnym wykorzystaniu swoich kwalifikacji.

## Osobiste starania jako część obowiązku

Codzienna opieka nad dzieckiem jest formą wykonywania obowiązku alimentacyjnego. Rodzic sprawujący opiekę na co dzień realizuje swoją część w naturze — i to wpływa na rozkład ciężaru finansowego.

> Dowody mają większe znaczenie niż argumentacja. Zestawienie wydatków z dokumentami przekonuje sąd skuteczniej niż opis sytuacji.`,
    },
  ],

  /* ------------------------------------------------------- strony prawne */
  legal: {
    regulamin: {
      slug: "regulamin",
      title: "Regulamin świadczenia usług drogą elektroniczną",
      updated: "2026-09-04",
      body: `*Stan prawny uwzględniony w Regulaminie: 31 sierpnia 2026 r.*
*Regulamin wchodzi w życie dnia [UZUPEŁNIĆ DATĘ].*

## § 1. Postanowienia ogólne i dane Usługodawcy

**1.** Niniejszy Regulamin określa zasady korzystania z serwisu internetowego Prawly, zawierania i wykonywania umów o odpłatne usługi prawne oraz świadczenia nieodpłatnych usług drogą elektroniczną, w tym prowadzenia Konta i udostępniania formularzy.

**2.** Usługodawcą i stroną umów zawieranych z Klientami jest Adrian Tomys prowadzący działalność gospodarczą pod firmą A2 Synergy Adrian Tomys, ul. Parkowa 44/1, 52-200 Wysoka, wpisany do Centralnej Ewidencji i Informacji o Działalności Gospodarczej, NIP PL9231689650, REGON 381660304 („Prawly" albo „Usługodawca"). Prawly jest oznaczeniem serwisu prowadzonego przez Usługodawcę.

**3.** Serwis jest dostępny pod adresem https://prawly.pl. Kontakt z Usługodawcą jest możliwy pod adresem e-mail kontakt@prawly.pl, przez formularz w Serwisie oraz listownie na adres wskazany w ust. 2.

**4.** Regulamin jest udostępniany nieodpłatnie przed zawarciem umowy w sposób umożliwiający jego pozyskanie, utrwalenie i odtworzenie. Klient otrzymuje potwierdzenie zawarcia umowy, zaakceptowany Regulamin i wymagane informacje konsumenckie na trwałym nośniku, w szczególności pocztą elektroniczną.

**5.** Regulamin jest regulaminem, o którym mowa w art. 8 ustawy o świadczeniu usług drogą elektroniczną. W zakresie nieuregulowanym stosuje się w szczególności Kodeks cywilny, ustawę o prawach konsumenta, przepisy o ochronie danych osobowych oraz właściwe przepisy regulujące wykonywanie zawodu radcy prawnego lub adwokata.

## § 2. Definicje

**1.** Serwis – prowadzona przez Prawly platforma internetowa umożliwiająca założenie Konta, złożenie Zamówienia, przekazanie informacji i dokumentów, komunikację w Sprawie oraz odbiór Rezultatu.

**2.** Klient – osoba fizyczna, osoba prawna albo jednostka organizacyjna składająca Zamówienie lub korzystająca z Konta.

**3.** Konsument – osoba fizyczna dokonująca z Prawly czynności prawnej niezwiązanej bezpośrednio z jej działalnością gospodarczą lub zawodową.

**4.** Przedsiębiorca na prawach konsumenta – osoba fizyczna zawierająca umowę bezpośrednio związaną z jej działalnością gospodarczą, gdy z treści umowy wynika, że nie ma ona dla tej osoby charakteru zawodowego, w zakresie ochrony przyznanej jej przez bezwzględnie obowiązujące przepisy.

**5.** Prawnik – radca prawny lub adwokat posiadający ważne uprawnienia zawodowe, wykonujący merytoryczną część Usługi na zlecenie Prawly albo kancelarii współpracującej z Prawly.

**6.** Kancelaria współpracująca – OLC Kancelaria Radców Prawnych Artymionek & Citko sp. k. albo inna kancelaria wskazana Klientowi przed przyjęciem Zamówienia do realizacji.

**7.** Usługa – odpłatne przygotowanie Opinii prawnej albo Dokumentu prawnego w zakresie określonym w Zamówieniu, wraz z jednym Pytaniem uzupełniającym.

**8.** Opinia prawna – pisemna odpowiedź na jedno oznaczone zagadnienie prawne, sporządzona na podstawie informacji i dokumentów przekazanych przez Klienta, obejmująca co najmniej zwięzłą ocenę prawną i rekomendację dalszego działania, w zakresie opisanym w karcie Usługi.

**9.** Dokument prawny – tekst dokumentu przygotowany według danych i celu wskazanych przez Klienta, przeznaczony do dalszego wykorzystania po wykonaniu wskazanych w nim lub w instrukcji czynności, w szczególności po uzupełnieniu danych, podpisaniu lub wniesieniu do właściwego organu.

**10.** Rezultat – finalna Opinia prawna albo Dokument prawny udostępniony Klientowi w Serwisie lub na trwałym nośniku, zatwierdzony przez Prawnika i oznaczony jego imieniem, nazwiskiem, tytułem zawodowym i numerem wpisu.

**11.** Kompletne Zgłoszenie – Zamówienie opłacone, obejmujące jedno dostatecznie sprecyzowane zagadnienie, poprawne dane Klienta i stron Sprawy, cel Usługi, istotne terminy oraz czytelne dokumenty niezbędne do wykonania Usługi.

**12.** Godziny Robocze – godziny od 9:00 do 17:00 czasu polskiego w dni od poniedziałku do piątku, z wyłączeniem dni ustawowo wolnych od pracy w Polsce.

**13.** Narzędzie AI – system sztucznej inteligencji używany pomocniczo do porządkowania materiału, wyszukiwania, tworzenia projektu lub kontroli redakcyjnej; Narzędzie AI nie jest Prawnikiem i nie zatwierdza Rezultatu.

**14.** Pytanie uzupełniające – jedno pytanie Klienta dotyczące wyjaśnienia Rezultatu, oparte na tym samym stanie faktycznym i niewymagające odrębnej analizy nowego zagadnienia.

**15.** Usługa – Opinia prawna – usługa polegająca na udzieleniu odpowiedzi prawnej na zadane przez Klienta pytanie prawne bez sporządzenia dokumentu prawnego.

**16.** Usługa – Dokument prawny – usługa polegająca na sporządzeniu określonego dokumentu, którym Klient będzie mógł posłużyć się w określonej sytuacji. Usługa nie obejmuje sporządzania pism procesowych.

## § 3. Model świadczenia pomocy prawnej i rola Prawnika

**1.** Prawly jest stroną umowy z Klientem, przyjmuje płatność i odpowiada za wykonanie Usługi na zasadach określonych w Regulaminie i przepisach prawa. Prawly nie jest kancelarią prawną i nie wykonuje zawodu radcy prawnego ani adwokata.

**2.** Merytoryczna część Usługi jest powierzana Prawnikowi. Prawnik wykonuje czynności zawodowe niezależnie, zgodnie z prawem, wiedzą zawodową, zasadami etyki i obowiązkiem zachowania tajemnicy zawodowej. Prawly nie może nakazać Prawnikowi przyjęcia określonej oceny prawnej.

**3.** Powierzenie wykonania Usługi Prawnikowi lub Kancelarii współpracującej nie wyłącza odpowiedzialności kontraktowej Prawly wobec Klienta w zakresie, w którym wynika ona z bezwzględnie obowiązujących przepisów. Odpowiedzialność zawodowa i dyscyplinarna Prawnika pozostaje niezależna.

**4.** Zawarcie umowy z Prawly nie obejmuje reprezentacji przed sądem, urzędem ani osobą trzecią, przyjęcia pełnomocnictwa, prowadzenia negocjacji, monitorowania biegu terminów, dokonania czynności za Klienta ani stałej obsługi prawnej, chyba że odrębna oferta zaakceptowana przez Klienta wyraźnie stanowi inaczej.

**5.** Jeżeli w toku wykonania Usługi okaże się, że pomoc powinna być świadczona bezpośrednio przez oznaczoną kancelarię lub Prawnika na podstawie odrębnej umowy, Prawly przedstawi Klientowi jej warunki. Brak akceptacji odrębnej oferty nie narusza praw Klienta dotyczących Zamówienia już przyjętego przez Prawly.

## § 4. Rola sztucznej inteligencji i nadzór człowieka

**1.** Prawly może korzystać z Narzędzi AI wyłącznie jako narzędzi wspierających pracę organizacyjną, analityczną lub redakcyjną. Klient nie otrzymuje jako Rezultatu nieweryfikowanej odpowiedzi wygenerowanej automatycznie.

**2.** Każdy Rezultat jest przed udostępnieniem Klientowi merytorycznie weryfikowany, poprawiany i zatwierdzany przez Prawnika, który bierze zawodową odpowiedzialność za przyjętą treść.

**3.** Prawly i Prawnik oceniają adekwatność źródeł oraz aktualność podstaw prawnych. Sam fakt wykorzystania Narzędzia AI nie zmniejsza wymaganego poziomu należytej staranności.

**4.** Materiały Klienta mogą być przetwarzane z użyciem dostawców technologicznych wyłącznie w zakresie niezbędnym do wykonania umowy, na warunkach zapewniających poufność, bezpieczeństwo i ochronę danych opisanych w Polityce prywatności. Treść Sprawy nie może być wykorzystywana do trenowania publicznie dostępnych modeli ani do celów marketingowych bez odrębnej podstawy prawnej.

**5.** W procesie przygotowania Rezultatu może zostać użyte Narzędzie AI. Prawly nie podejmuje wobec Klienta decyzji wywołującej skutki prawne wyłącznie w sposób zautomatyzowany.

**6.** Klient nie jest uprawniony do żądania ujawnienia poufnych instrukcji systemowych, promptów, kodu źródłowego ani informacji chronionych prawami osób trzecich. Ograniczenie to nie narusza ustawowych praw Klienta do informacji, wyjaśnienia sposobu wykonania Usługi ani dochodzenia roszczeń.

## § 5. Wymagania techniczne i zasady korzystania z Serwisu

**1.** Do korzystania z Serwisu potrzebne są:

- urządzenie z aktualnym systemem operacyjnym i dostępem do Internetu;
- aktualna przeglądarka internetowa obsługująca JavaScript, pliki cookies niezbędne i szyfrowanie TLS;
- aktywne konto poczty elektronicznej oraz program umożliwiający odczyt plików PDF;
- w przypadku przesyłania załączników – pliki w formatach i rozmiarach wskazanych w formularzu.

**2.** Klient odpowiada za poufność danych dostępowych do Konta i powinien niezwłocznie poinformować Prawly o podejrzeniu przejęcia Konta. Prawly nie przypisuje Klientowi skutków operacji dokonanych po prawidłowym zgłoszeniu utraty kontroli nad Kontem.

**3.** Zabronione jest dostarczanie treści bezprawnych oraz korzystanie z Serwisu w sposób naruszający prawo lub bezpieczeństwo, w szczególności:

- podszywanie się pod inną osobę lub podawanie danych nieprawdziwych;
- przesyłanie złośliwego kodu, automatyczne odpytywanie Serwisu, obchodzenie zabezpieczeń lub testowanie podatności bez zgody;
- zlecanie przygotowania treści służących popełnieniu przestępstwa, obejściu prawa lub naruszeniu praw osoby trzeciej;
- przesyłanie danych osób trzecich w zakresie oczywiście zbędnym dla Sprawy.

**4.** Prawly może przeprowadzać zapowiedziane prace techniczne oraz podejmować niezwłoczne działania konieczne dla bezpieczeństwa. W miarę możliwości prace planowe są prowadzone poza Godzinami Roboczymi.

## § 6. Konto Klienta

**1.** Założenie Konta jest nieodpłatne i wymaga podania prawdziwych danych, ustanowienia hasła oraz akceptacji Regulaminu. Konto służy jednej osobie albo jednemu oznaczonemu podmiotowi, chyba że Serwis umożliwia dodanie upoważnionych użytkowników.

**2.** Umowa o prowadzenie Konta jest zawierana na czas nieoznaczony z chwilą potwierdzenia rejestracji. Klient może w każdym czasie zażądać usunięcia Konta, z zastrzeżeniem przechowywania danych koniecznych do wykonania umów, realizacji obowiązków prawnych, zachowania tajemnicy zawodowej oraz ustalenia, dochodzenia lub obrony roszczeń.

**3.** Prawly może zawiesić Konto w razie uzasadnionego podejrzenia naruszenia prawa, bezpieczeństwa, Regulaminu lub praw osób trzecich. Jeżeli zagrożenie nie wymaga natychmiastowego działania, Prawly uprzednio wzywa Klienta do zaprzestania naruszeń.

**4.** Usunięcie albo zawieszenie Konta nie może pozbawiać Klienta dostępu do Rezultatu lub dokumentów rozliczeniowych dotyczących prawidłowo opłaconej Usługi bez zapewnienia innego sposobu ich otrzymania.

## § 7. Składanie Zamówienia, płatność i zawarcie umowy

**1.** Przed złożeniem Zamówienia Klient otrzymuje jasną informację o rodzaju i zakresie Usługi, cenie brutto, sposobie płatności, Terminie realizacji, głównych ograniczeniach oraz danych Usługodawcy. Dla Klienta niebędącego Konsumentem cena może być prezentowana również jako kwota netto, z jednoznacznym wskazaniem podatku. Klient może wybrać usługę polegającą na sporządzeniu opinii prawnej (Usługa – Opinia prawna) lub polegającą na sporządzeniu dokumentu prawnego (Usługa – Dokument prawny). Jeżeli Klient dokona nieprawidłowego wyboru rodzaju usługi, Prawly dokona weryfikacji wybranej usługi i skontaktuje się z Klientem celem dokonania korekty.

**2.** Złożenie Zamówienia przyciskiem oznaczonym jednoznacznie jako powodujący obowiązek zapłaty stanowi ofertę zawarcia umowy. Automatyczne potwierdzenie otrzymania Zamówienia nie oznacza jeszcze jego przyjęcia, jeżeli komunikat wyraźnie tak stanowi.

**3.** Prawly weryfikuje zakres Sprawy, kompletność danych, możliwość zachowania Terminu realizacji, kompetencje Prawnika i ewentualny konflikt interesów. Przyjęcie Zamówienia następuje przez wiadomość lub zmianę statusu na „przyjęte do realizacji". Prawly dokonuje przyjęcia albo odmowy bez zbędnej zwłoki, co do zasady w ciągu pierwszej Godziny Roboczej przypadającej po otrzymaniu Kompletnego Zgłoszenia.

**4.** Termin realizacji liczony zgodnie z § 9 nie ulega wydłużeniu wskutek wewnętrznej weryfikacji, o której mowa w ust. 3.

**5.** Płatność obsługuje system płatności Paynow. Podmiotem świadczącym obsługę płatności online jest mElements S.A. z siedzibą w Warszawie (00-838), ul. Prosta 18, wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego pod numerem KRS 0000590484, NIP 5223047892, REGON 363203696. Zapłaty można dokonać kartą płatniczą (Visa, Visa Electron, Mastercard, Mastercard Electronic, Maestro), przez BLIK lub przelewem online, zgodnie z metodami udostępnionymi w danym momencie przez Paynow. Za moment zapłaty uznaje się otrzymanie przez Prawly potwierdzenia poprawnej autoryzacji płatności; w przypadku płatności kartą płatniczą termin realizacji, o którym mowa w § 9, liczy się od momentu pozytywnej autoryzacji transakcji kartą. Prawly wystawia dokument sprzedaży zgodnie z przepisami.

**6.** Prawly może odmówić przyjęcia Zamówienia, w szczególności gdy:

- występuje konflikt interesów lub ryzyko naruszenia tajemnicy zawodowej;
- Sprawa wykracza poza ofertę, wymaga reprezentacji, czynności notarialnej, opinii biegłego, prawa obcego albo specjalizacji niedostępnej w Terminie realizacji;
- Zgłoszenie jest bezprawne, pozorne, ma służyć obejściu prawa lub narusza zasady etyki zawodowej;
- dane lub dokumenty są nieczytelne, sprzeczne, niewystarczające albo nie zostały uzupełnione mimo wezwania;
- dochowanie wskazanego przez Klienta terminu zewnętrznego nie jest obiektywnie możliwe.

**7.** W razie odmowy przyjęcia Zamówienia Prawly zwraca całą otrzymaną płatność niezwłocznie, nie później niż w terminie 14 dni, tym samym sposobem płatności, chyba że Klient wyraźnie uzgodni inny nieodpłatny sposób zwrotu. W przypadku płatności kartą płatniczą zwrot następuje na tę samą kartę. Prawly nie pobiera opłaty za samą odmowę. Prawly wystawia korektę faktury otrzymanej przez Klienta przy składaniu Zamówienia.

**8.** Jeżeli Sprawa może zostać wykonana dopiero po zmianie zakresu, ceny albo terminu, Prawly przedstawia nową ofertę. Brak wyraźnej akceptacji powoduje odmowę przyjęcia albo zakończenie niewykonanej części Zamówienia i odpowiedni zwrot.

## § 8. Zakres Usługi i Pytanie uzupełniające

**1.** Jedno Zamówienie obejmuje jedno główne zagadnienie prawne albo jeden rodzaj Dokumentu prawnego, w granicach karty Usługi i informacji wyświetlonych w formularzu. Kilka roszczeń opartych na różnych podstawach, kilka niezależnych dokumentów albo analiza kilku wersji umowy mogą stanowić odrębne Usługi.

**2.** Rezultat jest przygotowywany na podstawie prawa polskiego obowiązującego w dniu jego zatwierdzenia, chyba że oferta wyraźnie obejmuje inny porządek prawny lub ocenę historycznego stanu prawnego.

**3.** Objętość opisu, liczba i rozmiar załączników oraz planowana objętość Rezultatu wynikają z karty Usługi lub formularza Zamówienia. Prawly nie może po zawarciu umowy jednostronnie zmniejszyć zakresu wskazanego przed zakupem.

**4.** W cenie Usługi zawarte jest jedno Pytanie uzupełniające złożone w ciągu 7 dni od udostępnienia Rezultatu. Prawly odpowiada na nie w ciągu 2 Dni Roboczych, chyba że w karcie Usługi wskazano termin korzystniejszy.

**5.** Pytanie uzupełniające nie obejmuje nowego stanu faktycznego, nowego dokumentu, polemiki wymagającej ponownej pełnej analizy ani sporządzenia kolejnej wersji według zmienionych założeń. Jeżeli pytanie wykracza poza zakres, Prawly informuje o tym przed rozpoczęciem dodatkowo płatnej pracy.

**6.** Korekta oczywistej omyłki, błędu technicznego lub niezgodności Rezultatu z uzgodnionym zakresem nie jest Pytaniem uzupełniającym i jest wykonywana nieodpłatnie w ramach odpowiedzialności za prawidłowe wykonanie umowy.

## § 9. Termin realizacji

**1.** Jeżeli karta Usługi nie przewiduje terminu krótszego, Rezultat jest udostępniany w terminie 12 Godzin Roboczych w przypadku zamówienia opinii prawnej lub dokumentu prawnego oraz w terminie 24 Godzin Roboczych w przypadku zamówienia pakietu opinia + dokument, licząc od późniejszego z następujących zdarzeń: skutecznego opłacenia Zamówienia albo otrzymania Kompletnego Zgłoszenia.

**2.** Część terminu przypadająca poza Godzinami Roboczymi przechodzi na kolejne Godziny Robocze. Przykładowo Zamówienie kompletne w piątek o 15:00 powinno zostać wykonane najpóźniej w poniedziałek o 13:00, jeżeli poniedziałek jest Dniem Roboczym.

**3.** Jeżeli Prawnik zada pytanie niezbędne do wykonania Usługi, bieg terminu ulega zawieszeniu od wysłania pytania do otrzymania kompletnej odpowiedzi Klienta. Pytanie powinno wskazywać, jakiej informacji brakuje. Zawieszenie nie może służyć obchodzeniu Terminu realizacji.

**4.** Klient powinien podać wszystkie znane terminy ustawowe, sądowe, urzędowe i umowne. Prawly nie przyjmuje obowiązku monitorowania tych terminów ani dokonania czynności w imieniu Klienta, chyba że odrębna umowa stanowi inaczej.

**5.** Jeżeli przed przyjęciem Zamówienia Prawly stwierdzi, że rzetelne wykonanie w terminie 24 Godzin Roboczych nie jest możliwe, przedstawia Klientowi proponowany dłuższy termin. Umowa na zmienionych warunkach dochodzi do skutku wyłącznie po wyraźnej akceptacji Klienta; w przeciwnym razie następuje pełny zwrot.

**6.** Jeżeli po przyjęciu Zamówienia wykonanie w terminie stanie się niemożliwe z przyczyn, za które Prawly nie ponosi odpowiedzialności, Prawly niezwłocznie informuje Klienta i proponuje nowy termin albo zwrot. Postanowienie to nie ogranicza ustawowych praw Konsumenta w razie opóźnienia ani odpowiedzialności Prawly za okoliczności, za które odpowiada.

**7.** Samo przekroczenie terminu nie pozbawia Klienta roszczeń wynikających z prawa. Klient nie ma obowiązku zgłaszania opóźnienia w skróconym terminie pod rygorem utraty uprawnień.

## § 10. Obowiązki Klienta i założenia merytoryczne

**1.** Klient jest zobowiązany:

- opisać stan faktyczny zgodnie z prawdą, kompletnie i chronologicznie;
- przekazać wszystkie dokumenty, informacje o wcześniejszych czynnościach i rozstrzygnięciach, które mogą mieć znaczenie;
- wskazać strony Sprawy i podmioty powiązane w zakresie potrzebnym do sprawdzenia konfliktu interesów;
- podać konkretne terminy i nie odkładać złożenia Zamówienia do chwili uniemożliwiającej bezpieczne działanie;
- sprawdzić dane identyfikacyjne, kwoty, daty i ustalenia faktyczne w otrzymanym Dokumencie przed jego użyciem;
- nie modyfikować Rezultatu w sposób zmieniający jego sens bez konsultacji z prawnikiem.

**2.** Prawly i Prawnik nie mają obowiązku prowadzenia postępowania dowodowego, potwierdzania autentyczności dokumentów ani samodzielnego wyszukiwania faktów niewskazanych przez Klienta, chyba że zakres Usługi wyraźnie to obejmuje.

**3.** Jeżeli Klient działa za inną osobę lub podmiot, zapewnia, że jest umocowany do zlecenia Usługi i przekazania potrzebnych danych oraz dokumentów. Na żądanie przedstawia umocowanie.

**4.** Klient powinien ograniczyć dane osób trzecich do informacji niezbędnych dla Sprawy. Jeżeli to możliwe bez szkody dla analizy, powinien zanonimizować dane nadmiarowe.

## § 11. Charakter Rezultatu i sposób korzystania

**1.** Usługa jest zobowiązaniem do działania z należytą starannością właściwą dla profesjonalnych usług prawnych, a nie zobowiązaniem do osiągnięcia określonego wyniku sporu, decyzji organu lub zachowania osoby trzeciej.

**2.** Ocena prawna może zależeć od wykładni, praktyki organów, oceny dowodów i nieujawnionych okoliczności. Istnienie rozbieżnego poglądu prawnego lub późniejsze niekorzystne rozstrzygnięcie nie oznacza samo przez się nienależytego wykonania Usługi.

**3.** Rezultat jest przeznaczony dla Klienta i stanu faktycznego wskazanego w Zamówieniu. Nie powinien być stosowany do innej sprawy, innych stron, innego okresu ani po istotnej zmianie prawa bez aktualizacji.

**4.** Oznaczenie Rezultatu imieniem, nazwiskiem, tytułem zawodowym i numerem wpisu Prawnika potwierdza jego autorstwo lub zatwierdzenie merytoryczne. Graficzne odwzorowanie podpisu, pieczęci lub identyfikator elektroniczny nie stanowi kwalifikowanego podpisu elektronicznego, podpisu zaufanego ani osobistego, chyba że Rezultat wyraźnie wskazuje zastosowanie takiego podpisu.

**5.** Dokument prawny przygotowany dla Klienta może wymagać jego podpisu, podpisu innych stron, opłaty, złożenia przez właściwy kanał, dołączenia dowodów lub zachowania szczególnej formy. Informacja o sposobie użycia nie oznacza, że Prawly dokona tych czynności za Klienta.

**6.** Prawly nie świadczy w ramach standardowej Usługi doradztwa podatkowego, księgowego, inwestycyjnego ani technicznego, chyba że karta Usługi wyraźnie je obejmuje.

## § 12. Odpowiedzialność

**1.** Prawly ponosi odpowiedzialność za niewykonanie lub nienależyte wykonanie umowy na zasadach wynikających z obowiązujących przepisów, z uwzględnieniem profesjonalnego charakteru merytorycznej części Usługi.

**2.** Prawly nie odpowiada w zakresie, w jakim szkoda jest następstwem okoliczności leżących po stronie Klienta lub osoby trzeciej, za którą Prawly nie odpowiada, w szczególności:

- podania informacji nieprawdziwych, niepełnych, nieaktualnych lub przekazanych po zatwierdzeniu Rezultatu;
- nieprzekazania dokumentu, terminu, decyzji lub korespondencji mających znaczenie dla Sprawy;
- użycia Rezultatu poza uzgodnionym zakresem, po jego samodzielnej modyfikacji albo po zmianie prawa lub stanu faktycznego;
- niedokonania przez Klienta wymaganej czynności, niezachowania formy, terminu lub instrukcji wyraźnie wskazanej w Rezultacie;
- decyzji sądu, organu lub kontrahenta, której przy zachowaniu należytej staranności nie można było zagwarantować;
- awarii urządzenia, łącza lub oprogramowania po stronie Klienta.

**3.** Wyłączenia z ust. 2 mają zastosowanie wyłącznie w granicach normalnego związku przyczynowego i w zakresie, w jakim dana okoliczność faktycznie przyczyniła się do szkody. Nie wyłączają odpowiedzialności Prawly za własne zawinione działanie lub zaniechanie.

**4.** Wobec Konsumenta i Przedsiębiorcy na prawach konsumenta Regulamin nie wyłącza ani nie ogranicza odpowiedzialności i uprawnień, których zgodnie z prawem nie można wyłączyć lub ograniczyć wzorcem umownym.

**5.** Wobec Klienta niebędącego Konsumentem ani Przedsiębiorcą na prawach konsumenta odpowiedzialność Prawly za utracone korzyści i szkody pośrednie jest wyłączona, a łączna odpowiedzialność z tytułu jednego Zamówienia jest ograniczona do trzykrotności ceny netto zapłaconej za to Zamówienie.

**6.** Ograniczenie z ust. 5 nie dotyczy szkody wyrządzonej umyślnie lub wskutek rażącego niedbalstwa, szkody na osobie, naruszenia poufności lub ochrony danych ani przypadków, w których ograniczenie odpowiedzialności jest niedopuszczalne z mocy prawa.

**7.** Prawly nie wprowadza umownego terminu zawitego na zgłoszenie roszczeń. Klient powinien jednak zgłosić problem bez zbędnej zwłoki, jeżeli pozwoli to ograniczyć szkodę lub poprawić Rezultat.

## § 13. Prawo odstąpienia od umowy

**1.** Konsument oraz – w ustawowym zakresie – Przedsiębiorca na prawach konsumenta może odstąpić od umowy zawartej na odległość bez podania przyczyny w terminie 14 dni od dnia jej zawarcia.

**2.** Oświadczenie można złożyć przez formularz w Serwisie, pocztą elektroniczną na adres kontakt@prawly.pl albo listownie na adres Prawly. Można skorzystać ze wzoru stanowiącego Załącznik nr 1, lecz nie jest to obowiązkowe. Do zachowania terminu wystarcza wysłanie oświadczenia przed jego upływem.

**3.** Jeżeli Klient chce otrzymać Rezultat w Terminie realizacji przed upływem 14 dni, składa wyraźne żądanie rozpoczęcia świadczenia przed upływem terminu do odstąpienia. Żądanie nie może wynikać z domyślnie zaznaczonego pola ani z samej akceptacji Regulaminu.

**4.** Po pełnym wykonaniu Usługi Konsument traci prawo odstąpienia wyłącznie wtedy, gdy przed rozpoczęciem świadczenia wyraził zgodę na pełne wykonanie Usługi przed upływem 14 dni, został poinformowany o utracie prawa odstąpienia po pełnym wykonaniu i przyjął to do wiadomości.

**5.** Samo opłacenie Zamówienia, przyjęcie go przez Prawnika, rozpoczęcie analizy albo częściowe wykonanie Usługi nie powoduje utraty prawa odstąpienia.

**6.** Jeżeli Konsument skutecznie odstąpi po wyraźnym żądaniu rozpoczęcia świadczenia, lecz przed pełnym wykonaniem, zapłaci kwotę proporcjonalną do zakresu świadczenia spełnionego do chwili poinformowania Prawly o odstąpieniu. Prawly dokumentuje wykonane etapy i czas pracy. Konsument nie ponosi tych kosztów, jeżeli nie zażądał rozpoczęcia świadczenia albo nie otrzymał wymaganych informacji.

**7.** Prawly zwraca należne płatności nie później niż w terminie 14 dni od otrzymania oświadczenia, przy użyciu tego samego sposobu płatności, chyba że Klient wyraźnie zgodził się na inny sposób bez dodatkowych kosztów. W przypadku płatności kartą płatniczą zwrot następuje na tę samą kartę.

**8.** Postanowienia dotyczące treści cyfrowych niezapisanych na nośniku materialnym stosuje się tylko do odrębnych produktów, które rzeczywiście stanowią treści cyfrowe, a nie do usługi indywidualnej analizy prawnej tylko dlatego, że jej Rezultat przekazano w PDF.

## § 14. Reklamacje

**1.** Klient może złożyć reklamację dotyczącą Usługi, Konta, płatności lub działania Serwisu przez formularz, pocztą elektroniczną na adres kontakt@prawly.pl albo listownie. Prawly nie uzależnia przyjęcia reklamacji od wcześniejszego użycia określonego kanału.

**2.** Dla sprawnego rozpoznania reklamacja powinna wskazywać dane pozwalające zidentyfikować Klienta i Zamówienie, opis problemu, datę jego wystąpienia, dostępne dowody oraz oczekiwany sposób rozwiązania. Brak tych danych nie powoduje odrzucenia reklamacji, jeżeli można ją rozpoznać; Prawly może poprosić o uzupełnienie informacji.

**3.** Prawly rozpatruje reklamację Konsumenta w terminie 14 dni od jej otrzymania i przekazuje odpowiedź na papierze lub innym trwałym nośniku. Brak odpowiedzi w tym terminie wywołuje skutki określone w obowiązujących przepisach.

**4.** W zależności od charakteru nieprawidłowości Prawly może w szczególności poprawić lub uzupełnić Rezultat, ponownie wykonać Usługę, obniżyć cenę albo zwrócić całość lub część zapłaty. Postanowienie to nie wyłącza innych uprawnień ustawowych.

**5.** Ocena reklamacji dotyczącej treści prawnej powinna zostać przeprowadzona przez Prawnika innego niż autor Rezultatu, o ile jest to możliwe, z zachowaniem tajemnicy zawodowej i niezależności oceny.

**6.** Po nieuwzględnieniu reklamacji Konsument może skorzystać z pozasądowego rozwiązywania sporów konsumenckich. Informacje i rejestr podmiotów uprawnionych znajdują się na stronie polubowne.uokik.gov.pl. Prawly w odpowiedzi na reklamację informuje o właściwym podmiocie oraz o tym, czy wyraża zgodę na udział w postępowaniu.

**7.** Konsument może uzyskać bezpłatną pomoc miejskiego lub powiatowego rzecznika konsumentów albo organizacji konsumenckiej. Skorzystanie z procedur pozasądowych jest dobrowolne i nie wyłącza prawa do sądu.

## § 15. Poufność i dane osobowe

**1.** Prawly stosuje środki organizacyjne i techniczne mające chronić treść Sprawy. Dostęp do niej otrzymują wyłącznie osoby, Prawnik, Kancelaria współpracująca i dostawcy technologiczni w zakresie niezbędnym do wykonania ich zadań.

**2.** Prawnik zachowuje tajemnicę zawodową na zasadach wynikających z właściwych przepisów i zasad etyki. Klient przyjmuje do wiadomości, że Prawly jako podmiot technologiczny nie jest samorządem zawodowym ani kancelarią, dlatego zakres dostępu osób działających po stronie Prawly powinien być ograniczony do minimum niezbędnego do obsługi umowy.

**3.** Szczegółowe informacje o administratorze lub współadministratorach danych, celach, podstawach, odbiorcach, transferach, okresach przechowywania i prawach osób są zawarte w Polityce prywatności. Regulamin nie zastępuje obowiązku informacyjnego wynikającego z RODO.

**4.** Klient nie powinien przesyłać oryginałów jedynych egzemplarzy dokumentów. Dokumenty elektroniczne pozostają dostępne na zasadach wskazanych w Serwisie i Polityce prywatności; Prawly może wymagać ich pobrania przed zamknięciem Konta.

## § 16. Prawa własności intelektualnej

**1.** Prawly udziela Klientowi niewyłącznego, nieograniczonego terytorialnie prawa do korzystania z Rezultatu na potrzeby własnej Sprawy, w tym do jego kopiowania, modyfikowania, podpisania, przedłożenia sądowi, organowi, kontrahentowi, doradcy, ubezpieczycielowi lub innym osobom, którym udostępnienie jest potrzebne do realizacji celu Usługi.

**2.** Klient może udzielić pełnomocnikowi lub następcy prawnemu prawa do korzystania z Rezultatu w tej samej Sprawie.

**3.** Bez odrębnej zgody zabronione jest odsprzedawanie Rezultatu jako wzorca, masowe rozpowszechnianie, publikowanie w bazach komercyjnych, usuwanie oznaczenia autora w celu przypisania autorstwa innej osobie lub używanie Rezultatu do trenowania modelu konkurencyjnego.

**4.** Klient zachowuje prawa do materiałów, które przekazał. Udziela Prawly i osobom wykonującym Usługę niewyłącznego upoważnienia do korzystania z nich wyłącznie w zakresie niezbędnym do wykonania umowy, obsługi reklamacji i obrony roszczeń.

**5.** Prawly zachowuje prawa do Serwisu, oprogramowania, elementów identyfikacji, materiałów ogólnych, metod organizacji pracy i szablonów w zakresie, w jakim nie ogranicza to uprawnienia Klienta do korzystania z indywidualnego Rezultatu.

## § 17. Rozwiązanie umowy i blokada Konta

**1.** Klient może wypowiedzieć umowę o prowadzenie Konta w każdym czasie. Wypowiedzenie nie wpływa na umowę dotyczącą Zamówienia będącego w toku, chyba że Klient jednocześnie korzysta z prawa odstąpienia, wypowiedzenia lub innego uprawnienia dotyczącego tej Usługi.

**2.** Prawly może rozwiązać umowę o Konto z ważnej przyczyny, w szczególności trwałego zaprzestania Serwisu, poważnego lub powtarzającego się naruszenia Regulaminu, bezprawnego użycia albo zagrożenia bezpieczeństwa. Jeżeli nie zachodzi potrzeba natychmiastowej reakcji, Prawly wyznacza odpowiedni termin na usunięcie naruszenia.

**3.** W razie rozwiązania lub blokady Prawly rozlicza Usługi wykonane i zwraca kwoty należne za część niewykonaną. Nie może zatrzymać całej opłaty wyłącznie z tego powodu, że Konto zostało zawieszone.

**4.** Prawly zapewnia możliwość pobrania Rezultatów i dokumentów rozliczeniowych przez rozsądny okres albo przekazuje je na trwałym nośniku, chyba że ich udostępnienie byłoby bezprawne lub zagrażało bezpieczeństwu.

## § 18. Zmiany Regulaminu i postanowienia końcowe

**1.** Do pojedynczego Zamówienia stosuje się wersję Regulaminu zaakceptowaną przy jego składaniu. Późniejsza zmiana Regulaminu nie zmienia warunków już zawartej umowy bez wyraźnej zgody Klienta albo podstawy wynikającej z prawa.

**2.** Prawly może zmienić warunki nieodpłatnych usług ciągłych z ważnej przyczyny wskazanej w zawiadomieniu, w szczególności zmiany prawa, wymogów bezpieczeństwa, funkcjonalności lub danych Usługodawcy. O zmianie istotnej dla Klienta informuje na trwałym nośniku z co najmniej 14-dniowym wyprzedzeniem, umożliwiając wypowiedzenie umowy o Konto.

**3.** Prawem właściwym jest prawo polskie, z zastrzeżeniem ochrony przysługującej Konsumentowi na podstawie bezwzględnie obowiązujących przepisów państwa jego zwykłego pobytu.

**4.** Spory z Konsumentami rozpoznaje sąd właściwy zgodnie z przepisami. W sporach z Klientami niebędącymi Konsumentami ani Przedsiębiorcami na prawach konsumenta wyłącznie właściwy jest sąd właściwy dla siedziby Usługodawcy, o ile bezwzględnie obowiązujący przepis nie stanowi inaczej.

**5.** Nieważność albo bezskuteczność jednego postanowienia nie wpływa na pozostałe postanowienia. Wobec Konsumenta nie zastępuje się niewiążącej klauzuli postanowieniem pogarszającym jego sytuację ponad rozwiązanie wynikające z prawa.

**6.** Regulamin wchodzi w życie dnia [UZUPEŁNIĆ DATĘ].

---

## Załącznik nr 1 – wzór oświadczenia o odstąpieniu od umowy

*(formularz należy wypełnić i odesłać tylko w przypadku chęci odstąpienia od umowy)*

Adresat: A2 Synergy Adrian Tomys, ul. Parkowa 44/1, 52-200 Wysoka, e-mail: kontakt@prawly.pl

Niniejszym informuję o odstąpieniu od umowy dotyczącej następującej Usługi:

- Numer Zamówienia / Sprawy: ...............................................
- Data zawarcia umowy: ...............................................
- Imię i nazwisko Klienta: ...............................................
- Adres Klienta: ...............................................
- Adres e-mail przypisany do Konta: ...............................................
- Data: ...............................................
- Podpis (tylko jeżeli formularz jest przesyłany w wersji papierowej): ...............................................`,
    },
    prywatnosc: {
      slug: "polityka-prywatnosci",
      title: "Polityka prywatności",
      updated: "2026-09-16",
      body: `*Stan projektu: 31 sierpnia 2026 r. Dokument wymaga jeszcze weryfikacji kilku pól oznaczonych [UZUPEŁNIĆ] — patrz lista pod dokumentem, poza treścią przeznaczoną do publikacji.*

## § 1. Cel i zakres Polityki

**1.** Niniejsza Polityka wyjaśnia, w jaki sposób dane osobowe są przetwarzane w związku z korzystaniem z serwisu Prawly dostępnego pod adresem https://prawly.pl, założeniem Konta, złożeniem Zamówienia, płatnością, przekazaniem materiałów dotyczących Sprawy, komunikacją i otrzymaniem Rezultatu.

**2.** Polityka dotyczy Klientów, użytkowników Serwisu, osób kontaktujących się z Prawly, przedstawicieli i pracowników Klientów, a także osób, których dane znajdują się w opisie Sprawy lub załączonych dokumentach.

**3.** Pojęcia zapisane wielką literą mają znaczenie nadane im w Regulaminie Prawly, chyba że z niniejszej Polityki wynika inaczej.

## § 2. Kto jest administratorem danych

**4.** Administratorem danych przetwarzanych w celu prowadzenia Serwisu, Konta, sprzedaży i rozliczenia Usług, obsługi płatności, kontaktu operacyjnego, bezpieczeństwa oraz rozpatrywania reklamacji jest Adrian Tomys prowadzący działalność gospodarczą pod firmą A2 Synergy Adrian Tomys, ul. Parkowa 44/1, 52-200 Wysoka, NIP PL9231689650, REGON 381660304 („Prawly").

**5.** Z Prawly można skontaktować się: e-mail kontakt@prawly.pl, przez formularz w Serwisie lub listownie na adres wskazany powyżej. [UZUPEŁNIĆ ALBO USUNĄĆ: jeżeli Prawly powoła Inspektora Ochrony Danych, jego dane kontaktowe zostaną podane tutaj.]

**6.** Merytoryczną analizę prawną wykonuje OLC Kancelaria Radców Prawnych Artymionek & Citko sp. k. z siedzibą przy ul. Sarnia 4/1, 52-129 Wrocław [ZWERYFIKOWAĆ I UZUPEŁNIĆ: numer KRS] albo inna kancelaria lub Prawnik wskazani Klientowi przed przekazaniem im danych. W zakresie, w którym kancelaria lub Prawnik samodzielnie określają cele i sposoby przetwarzania wynikające z niezależności zawodowej, konfliktu interesów, tajemnicy zawodowej, obowiązków ustawowych, etycznych, ubezpieczeniowych lub obrony przed roszczeniami, są odrębnym administratorem. W zakresie czynności wykonywanych wyłącznie na udokumentowane polecenie Prawly mogą działać jako podmiot przetwarzający – zgodnie z rzeczywistym podziałem ról i zawartą umową.

**7.** Podział ról nie ogranicza praw osoby. Żądanie skierowane do niewłaściwego podmiotu zostanie – w granicach prawa i poufności – przekazane właściwemu adresatowi albo osoba zostanie poinformowana, gdzie je złożyć.

*Uwaga: nie należy publikować wspólnego określenia „Prawly i partnerzy są administratorami” bez ustalenia faktycznych ról. Status administratora, współadministratora albo podmiotu przetwarzającego wynika z rzeczywistego wpływu na cele i sposoby przetwarzania, a nie wyłącznie z nazwy umowy.*

## § 3. Jakie dane i skąd je otrzymujemy

**8.** W zależności od sposobu korzystania z Serwisu możemy przetwarzać następujące kategorie danych:

- dane identyfikacyjne i kontaktowe: imię, nazwisko, firma, stanowisko, adres, e-mail, numer telefonu oraz dane przedstawiciela lub pełnomocnika;
- dane Konta i uwierzytelniania: identyfikator, zaszyfrowane lub zahaszowane dane uwierzytelniające, historia logowań, ustawienia i zgody;
- dane transakcyjne i rozliczeniowe: wybrana Usługa, numer Zamówienia, kwota, status płatności, dane płatnika, NIP i dane do faktury; Prawly nie otrzymuje pełnego numeru karty — płatność obsługuje zewnętrzny operator (Paynow);
- treść Sprawy: pytania, opis stanu faktycznego, korespondencja, terminy, żądania i informacje potrzebne do identyfikacji stron lub konfliktu interesów;
- dokumenty i dane osób trzecich: treść umów, pism, orzeczeń, akt osobowych, dokumentacji medycznej lub rodzinnej oraz inne materiały przekazane przez Klienta;
- szczególne kategorie danych, jeżeli są niezbędne w Sprawie, np. dane o zdrowiu, pochodzeniu, poglądach, przekonaniach, przynależności związkowej, seksualności, dane genetyczne lub biometryczne;
- dane dotyczące wyroków skazujących i naruszeń prawa, jeżeli są niezbędne do wykonania Usługi i przetwarzane na podstawie właściwych przepisów;
- dane techniczne i eksploatacyjne: adres IP, identyfikatory urządzenia i sesji, typ przeglądarki, system operacyjny, znaczniki czasu, logi błędów, zdarzenia bezpieczeństwa;
- dane komunikacyjne i reklamacyjne dotyczące Usługi.

**9.** Dane otrzymujemy bezpośrednio od osoby, od Klienta działającego w imieniu organizacji, od osoby upoważnionej, z dokumentów przekazanych w Sprawie, od operatora płatności w zakresie statusu transakcji, z urządzenia i logów Serwisu, a gdy jest to potrzebne do analizy prawnej – z rejestrów publicznych i legalnie dostępnych źródeł.

**10.** Klient powinien przekazywać tylko dane adekwatne do Sprawy. Jeżeli pełne dane osoby trzeciej nie są potrzebne, należy je zanonimizować lub zamazać. Klient powinien mieć podstawę do przekazania danych i – gdy jest to wymagane oraz nie narusza celu pomocy prawnej lub tajemnicy – przekazać tej osobie informacje o przetwarzaniu.

## § 4. Cele, podstawy prawne i okresy przetwarzania

**11.** Zakres danych ograniczamy do informacji potrzebnych dla konkretnego celu. Poniżej cele przetwarzania wraz z podstawą prawną i okresem przechowywania; terminy oznaczone jako [UZUPEŁNIĆ] muszą odpowiadać rzeczywistym ustawieniom systemów.

**Konto i formularze.** Cel: założenie i prowadzenie Konta, uwierzytelnianie, obsługa funkcji Serwisu. Podstawa: art. 6 ust. 1 lit. b RODO (przed umową lub wykonanie umowy). Okres: do zamknięcia Konta, następnie ograniczony zbiór przez okres roszczeń/obowiązków.

**Zamówienie i Usługa.** Cel: przyjęcie, wykonanie, komunikacja, przekazanie Rezultatu. Podstawa: art. 6 ust. 1 lit. b RODO. Okres: przez wykonanie umowy, następnie przez właściwy okres roszczeń i dokumentacji zawodowej.

**Dane wrażliwe w Sprawie.** Cel: ustalenie, dochodzenie lub obrona roszczeń; pomoc prawna. Podstawa: art. 9 ust. 2 lit. f RODO; gdy ta podstawa nie wystarcza – inna właściwa podstawa, wyjątkowo wyraźna zgoda. Okres: jak dokumentacja Sprawy, z ograniczeniem dostępu.

**Dane karne.** Cel: pomoc prawna i obsługa roszczeń. Podstawa: art. 10 RODO w związku z właściwą podstawą prawa krajowego i zasadami wykonywania zawodu. Okres: tylko przez okres niezbędny i zgodny z właściwymi przepisami.

**Płatność i księgowość.** Cel: przyjęcie płatności, faktura, księgi, podatki. Podstawa: art. 6 ust. 1 lit. b i c RODO. Okres: przez okres wymagany przepisami podatkowymi i rachunkowymi.

**Reklamacje i roszczenia.** Cel: obsługa reklamacji, dowody, dochodzenie lub obrona roszczeń. Podstawa: art. 6 ust. 1 lit. b, c i f RODO (interes: ochrona praw). Okres: do zakończenia sprawy i upływu właściwych terminów przedawnienia.

**Logi i ochrona.** Cel: przeciwdziałanie nadużyciom, diagnostyka incydentów. Podstawa: art. 6 ust. 1 lit. f RODO (interes: bezpieczny i niezawodny Serwis). Okres: [UZUPEŁNIĆ — rekomendacja: np. 12 miesięcy], dłużej przy incydencie.

**Kontakt niezwiązany z umową.** Cel: odpowiedź na wiadomość i dalsza korespondencja. Podstawa: art. 6 ust. 1 lit. f RODO (interes: komunikacja i obsługa zapytań). Okres: do zakończenia kontaktu, następnie [UZUPEŁNIĆ].

**12.** Podanie danych oznaczonych w formularzu jako wymagane jest potrzebne do zawarcia lub wykonania umowy albo do wystawienia dokumentu księgowego. Bez nich Prawly może nie móc założyć Konta, przyjąć płatności lub wykonać Usługi. Dane opcjonalne są dobrowolne i ich brak nie wpływa na możliwość zakupu Usługi.

**13.** Po upływie podstawowego okresu dane mogą być przechowywane w ograniczonym zakresie, jeżeli wymaga tego prawo, tajemnica i obowiązki zawodowe, zabezpieczenie dowodów albo ustalenie, dochodzenie lub obrona roszczeń. Po ustaniu podstaw retencja kończy się usunięciem lub skuteczną anonimizacją; kopie zapasowe są nadpisywane w cyklu [UZUPEŁNIĆ, np. 90 dni].

## § 5. Dane Sprawy, poufność i tajemnica zawodowa

**14.** Treść Sprawy może zawierać informacje o bardzo wysokiej poufności. Dostęp otrzymują wyłącznie osoby, którym jest potrzebny do realizacji Usługi, utrzymania systemu, kontroli jakości, bezpieczeństwa lub wykonania obowiązków prawnych, w zakresie odpowiadającym ich roli.

**15.** Prawnik jest związany tajemnicą zawodową na zasadach właściwych dla radców prawnych albo adwokatów. Prawly i dostawcy technologiczni są objęci obowiązkami poufności wynikającymi z umów, procedur i przepisów. Polityka nie rozszerza wyjątków od tajemnicy zawodowej ani nie upoważnia do ujawnienia materiałów Sprawy.

**16.** Prawly nie wykorzystuje treści Spraw do reklamy, tworzenia profili marketingowych ani trenowania publicznie dostępnych modeli AI. Inne wykorzystanie danych do rozwoju własnego rozwiązania wymaga uprzedniego ustalenia zgodnej podstawy, przeprowadzenia oceny ryzyka i przekazania jasnej informacji; jeżeli podstawą jest zgoda, odmowa nie może wpływać na wykonanie zakupionej Usługi.

## § 6. Wykorzystanie sztucznej inteligencji

**17.** Narzędzia AI mogą wspierać porządkowanie materiału, wyszukiwanie, streszczanie, tworzenie projektu lub kontrolę redakcyjną. AI nie zastępuje Prawnika: każdy Rezultat przeznaczony dla Klienta jest weryfikowany, w razie potrzeby poprawiany i zatwierdzany przez oznaczonego Prawnika.

**18.** W ramach działania Narzędzia AI mogą być przetwarzane fragmenty opisu Sprawy i dokumentów, tylko w zakresie niezbędnym. Przed uruchomieniem należy stosować minimalizację lub pseudonimizację, jeżeli pozwala na to charakter Sprawy.

**19.** Dostawca AI: Anthropic PBC (model Claude, udostępniany w ramach Anthropic API). Rola: podmiot przetwarzający, w zakresie fragmentów opisu Sprawy i dokumentów przekazywanych do modelu w celu wspomagania przygotowania projektu odpowiedzi. Lokalizacja przetwarzania, dokładny okres retencji po stronie dostawcy oraz mechanizm transferu poza EOG: [ZWERYFIKOWAĆ w aktualnej umowie/warunkach handlowych z Anthropic — nie zakładam tu konkretnych wartości bez potwierdzenia]. Zasady wykorzystania wejść i wyjść do trenowania modeli: wymagane ustawienie — brak trenowania na danych Prawly bez odrębnej decyzji i podstawy.

**20.** Prawly nie podejmuje wobec Klienta decyzji wywołujących skutki prawne lub podobnie istotnie na niego wpływających wyłącznie automatycznie w rozumieniu art. 22 RODO. Jeżeli model usługi ulegnie zmianie, Polityka i interfejs zostaną zaktualizowane przed uruchomieniem takiej funkcji, wraz z wymaganymi zabezpieczeniami.

## § 7. Odbiorcy danych

**21.** Dane mogą otrzymywać wyłącznie podmioty, które potrzebują ich do realizacji określonego zadania:

- Kancelaria współpracująca i przypisany Prawnik – dla analizy prawnej, kontroli konfliktu interesów, zatwierdzenia i obsługi Sprawy;
- dostawcy hostingu, chmury, baz danych, kopii zapasowych, poczty, komunikacji i Narzędzi AI – zwykle jako podmioty przetwarzające;
- Paynow — podmiotem świadczącym obsługę płatności online jest mElements S.A. z siedzibą w Warszawie, ul. Prosta 18 — jako operator płatności, w zakresie niezbędnym do transakcji, jako odrębny administrator;
- Google Ireland Limited (Google Ads) – pomiar skuteczności kampanii reklamowych, wyłącznie po zgodzie wyrażonej w banerze cookies;
- Contentsquare Ireland Limited – analiza sposobu korzystania z Serwisu, w tym nagrania sesji i mapy cieplne, wyłącznie po zgodzie wyrażonej w banerze cookies;
- Meta Platforms Ireland Limited – potwierdzanie skuteczności reklam (Meta Conversions API), na podstawie zahaszowanego adresu e-mail, bez przekazywania danych w postaci jawnej;
- TikTok Technology Limited (TikTok Ads) – pomiar skuteczności kampanii reklamowych za pomocą piksela, wyłącznie po zgodzie wyrażonej w banerze cookies, oraz potwierdzanie skuteczności reklam po stronie serwera (TikTok Events API) na podstawie zahaszowanego adresu e-mail, bez przekazywania danych w postaci jawnej;
- biuro rachunkowe, audytorzy, doradcy podatkowi – w zakresie właściwym dla ich usług i obowiązków;
- organy publiczne, sądy i uprawnione podmioty – tylko gdy istnieje ważna podstawa prawna żądania lub obowiązek ujawnienia.

**22.** Aktualna, funkcjonalna lista kluczowych dostawców powinna być dostępna pod adresem [UZUPEŁNIĆ LINK] i wskazywać co najmniej nazwę, funkcję, rolę, państwo przetwarzania i podstawę transferu. Zmiana dostawcy nie może obniżać poziomu ochrony ani naruszać tajemnicy zawodowej.

## § 8. Przekazywanie danych poza Europejski Obszar Gospodarczy

**23.** Prawly preferuje przetwarzanie w EOG. Nie można jednak zadeklarować braku transferów bez sprawdzenia wszystkich dostawców, podwykonawców, zdalnego dostępu, telemetrii i kopii zapasowych — w szczególności dostawcy AI (§ 6 ust. 19), który może przetwarzać dane poza EOG.

**24.** Jeżeli dane są przekazywane do państwa poza EOG, Prawly stosuje mechanizm przewidziany w rozdziale V RODO, w szczególności decyzję Komisji Europejskiej stwierdzającą odpowiedni stopień ochrony albo standardowe klauzule umowne wraz z oceną warunków transferu i – gdy potrzeba – środkami dodatkowymi. Informację o mechanizmie i sposobie uzyskania kopii zabezpieczeń można uzyskać pod adresem kontakt@prawly.pl.

## § 9. Cookies i podobne technologie

**25.** Serwis zapisuje w przeglądarce użytkownika dane niezbędne do działania — identyfikator sesji zalogowanego użytkownika (local storage), potrzebny do utrzymania logowania. Za zgodą użytkownika, wyrażoną w banerze cookies przy pierwszej wizycie, Serwis korzysta też z Google Ads i TikTok Ads (pomiar skuteczności kampanii reklamowych) oraz Contentsquare (analiza sposobu korzystania z Serwisu, w tym nagrania sesji i mapy cieplne) — wszystkie trzy narzędzia zapisują własne pliki cookies wyłącznie po udzieleniu zgody, nigdy wcześniej.

**26.** Identyfikator sesji logowania jest technologią niezbędną do działania Serwisu — działa bez odrębnej zgody, zgodnie z przepisami. Zablokowanie go w przeglądarce uniemożliwia zalogowanie się do Serwisu.

**27.** Google Ads, TikTok Ads i Contentsquare są opcjonalne i uruchamiają się wyłącznie po zgodzie w banerze cookies. Zgodę można wycofać w dowolnym momencie, równie łatwo jak jej udzielić — link „Ustawienia cookies” w stopce Serwisu, dostępny na każdej podstronie.

## § 10. Marketing i media społecznościowe

**28.** Informacje handlowe e-mailem, SMS-em lub telefonicznie są wysyłane po uzyskaniu wymaganej, odrębnej zgody. Zgoda nie może być warunkiem zakupu Usługi. Można ją wycofać linkiem w wiadomości lub przez kontakt z Prawly.

*[UZUPEŁNIĆ ALBO USUNĄĆ: ten paragraf dotyczy profili Prawly w mediach społecznościowych — do uzupełnienia, jeśli takie profile istnieją, albo do usunięcia, jeśli nie.]*

## § 11. Bezpieczeństwo danych

**29.** Prawly stosuje środki techniczne i organizacyjne odpowiednie do ryzyka, w szczególności kontrolę uprawnień według ról, uwierzytelnianie, rejestrowanie zdarzeń, szyfrowanie transmisji, bezpieczne kopie zapasowe, aktualizacje i procedury obsługi incydentów. Zakres środków podlega okresowym przeglądom.

**30.** Żaden sposób przesyłania lub przechowywania danych nie daje absolutnej gwarancji bezpieczeństwa. Użytkownik powinien chronić hasło, korzystać z zaufanego urządzenia i przesyłać materiały Sprawy przez bezpieczny panel Serwisu, a nie zwykłym kanałem.

## § 12. Prawa osób

**31.** Na warunkach RODO osobie przysługuje prawo:

- dostępu do danych i otrzymania ich kopii;
- sprostowania nieprawidłowych danych oraz uzupełnienia danych;
- usunięcia danych, gdy zachodzi jedna z ustawowych przesłanek;
- ograniczenia przetwarzania;
- przenoszenia danych dostarczonych administratorowi, gdy przetwarzanie odbywa się automatycznie na podstawie zgody lub umowy;
- wniesienia sprzeciwu z przyczyn związanych ze szczególną sytuacją wobec przetwarzania opartego na art. 6 ust. 1 lit. f RODO oraz bezwarunkowego sprzeciwu wobec marketingu bezpośredniego;
- wycofania zgody w dowolnym czasie, bez wpływu na zgodność wcześniejszego przetwarzania;
- wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych — aktualny adres Urzędu: ul. Stanisława Moniuszki 1A, 00-014 Warszawa, uodo.gov.pl.

**32.** Żądanie dotyczące Prawly można wysłać na kontakt@prawly.pl. Żądanie dotyczące niezależnych czynności Kancelarii współpracującej można wysłać na adres podany przy przypisaniu Prawnika. Prawly lub kancelaria mogą poprosić o informacje potrzebne do rozsądnego potwierdzenia tożsamości; nie będą wymagać danych nadmiarowych.

**33.** Prawa nie mają charakteru absolutnego. Odmowa lub ograniczenie może wynikać m.in. z obowiązku prawnego, ochrony praw i wolności innych osób, tajemnicy zawodowej albo konieczności ustalenia, dochodzenia lub obrony roszczeń. Administrator wyjaśni podstawę decyzji i dostępne środki odwoławcze.

## § 13. Dane osób trzecich w dokumentach Klienta

**34.** Jeżeli Prawly otrzymuje dane nie od osoby, której dotyczą, źródłem jest zwykle Klient lub przekazany przez niego dokument. Kategorie i cele odpowiadają opisowi w § 3 i § 4, a odbiorcy – § 7.

**35.** Prawly i Kancelaria współpracująca oceniają indywidualnie, czy i kiedy należy przekazać osobie trzeciej dodatkową informację. Obowiązek może podlegać ustawowym wyjątkom, w szczególności gdy osoba ma już informacje, udzielenie informacji jest niemożliwe lub wymagałoby niewspółmiernego wysiłku, albo dane muszą pozostać poufne na podstawie obowiązku tajemnicy. Wyjątki nie są stosowane automatycznie.

## § 14. Dzieci

**36.** Usługi Prawly są przeznaczone dla osób pełnoletnich i podmiotów reprezentowanych przez uprawnione osoby. Prawly nie kieruje samodzielnych usług społeczeństwa informacyjnego do dzieci. Dane dziecka mogą jednak pojawić się w Sprawie rodzinnej, szkolnej, medycznej lub innej; są wtedy przetwarzane tylko w zakresie niezbędnym do pomocy prawnej, z podwyższoną ostrożnością i ograniczeniem dostępu.

## § 15. Zmiany Polityki

**37.** Polityka może być aktualizowana w razie zmian prawa, modelu Usługi, dostawców lub technologii. Aktualna wersja będzie dostępna w Serwisie z datą wejścia w życie. O zmianach istotnie wpływających na sposób przetwarzania użytkownik posiadający Konto zostanie poinformowany w odpowiedni sposób, np. e-mailem lub komunikatem w Serwisie.

**38.** Data wejścia w życie: 16 września 2026 r.`,
    },
  },
};

/* Kategorie wpisów wyliczane z treści — używane w filtrach bazy wiedzy. */
export const postCategories = (posts) => [
  ...new Set(posts.filter((p) => p.published).map((p) => p.cat)),
];
